<template>
    <div  v-loading="loading">
        <div class="title whiteBox">{{section.biddingType==0?$t('view.投标详情'):$t('view.报价详情')}}</div>
        <!-- 1 报名 2 资质审核、待提交 3 资质审核审核中 4 资质审核驳回 -->
        <!--  5 缴费待提交 6 缴费审核中  7 缴费驳回   -->
        <!-- 8项目标书待提交  9项目标书审核中  10 项目标书驳回 -->
         <!--11待开标  12 投标竞价  13 定标中  14定标 -->

         <!-- 1 报名 2 基础文件-待提交 3 基础文件-审核中 4 基础文件-驳回 -->
        <!--  5 资质审核-待提交 6 资质审核-审核中  7 资质审核-驳回     -->
        <!--8 缴费-待提交  9 缴费-审核中  10 缴费-驳回 -->
         <!--11 项目标书-待提交  12 项目标书-审核中  13 项目标书-驳回  -->
         <!-- 14 待开标  15 竞价中   -->
          <!--16 报价说明-待提交  17 报价说明-审核中  18 报价说明-驳回 -->
          <!-- 19 定标中  20 已定标 -->
           {{section.startTime}}
         <div v-if="section.biddingType==0" class="whiteBox">
            <BarKemajuan :schedule="details.supplierBidStatus" :list="scheduleList"></BarKemajuan>
            <div v-if="details.supplierBidStatus<15" style="font-size: 14px;margin-top: 10px;margin-left: 50px">
                <div>{{$t('view.开标倒计时')}}：<span style="color: #B80008;">{{section.bidOpeningList}}</span></div>
                <div style="margin-top: 5px">{{ $t('view.本项目开标进入倒计时阶段。请各位投标人提前做好开标相关准备，确保能准时参与开标活动。') }}</div>
            </div>
         </div>
        <div v-else class="whiteBox">
            <div v-if="details.supplierBidStatus!=20&&!details.disabled" style="display: flex;align-items: center;" >
                <div class="TypeBox">{{ $t('view.询价中') }}</div>
                <span>{{ $t('view.询价项目正在询价中，可以继续报价') }}</span>
            </div>
            <div v-else-if="details.supplierBidStatus==-1" style="display: flex;align-items: center;" >
                <div class="TypeBox">{{ $t('view.已弃标') }}</div>
            </div>
            <div v-else style="display: flex;align-items: center">
                <div class="TypeBox">{{ $t('view.询价结束') }}</div>
                <span>{{ $t('view.询价项目已结束，可以查看报价记录') }}</span>
            </div>
        </div>
        <!-- 开标报价 -->
        <div class="whiteBox" v-if="details.supplierBidStatus==15&&details.signStatus==1">
            <div class="title1" style="margin-bottom: 15px;">{{section.biddingType==0?$t('view.开标报价'):$t('view.报价入口')}}</div>
            <div style="font-weight: 600;font-size: 18px;color: #606266;margin-bottom:20px">{{section.biddingType==0?$t('view.该投标项目已正式开标。'):$t('view.该询价项目已开始报价')}}</div>
            <div style="color: #909399;font-size: 14px;margin-bottom:10px">{{ $t('view.点击报价按钮，前去报价') }}</div>
            <el-button v-if="!details.disabled" plain type="primary" @click="Jump('quotation',details.sectionId)">{{ $t('view.去报价') }}</el-button>
        </div>
       <!-- 基本信息 -->
        <div class="whiteBox">
            <div class="title1">{{ $t('view.基本信息') }}</div>
            <div class="box">
                <el-table :cell-style='rowClass' :span-method="objectSpanMethod"  :show-header="false" :data="basicTable" border style="margin-top:20px; width:100%">
                    <el-table-column align="center" width="150" prop="LeftTitle">
                          <template slot-scope="scope">
                            {{ scope.row.LeftTitle?scope.row.LeftTitle:'/' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="LeftValue">
                        <template slot-scope="scope">
                            <span v-if="scope.row.LeftValue==$t('view.招标公告')">
                                <span class="clickText"  @click="Jumps('PreviewDetails', details.sectionId)">{{ $t('view.招标公告') }}</span>
                            </span>
                            <span v-else>{{scope.row.LeftValue?scope.row.LeftValue:'/'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="150" prop="RightTitle">
                         <template slot-scope="scope">
                            {{ scope.row.RightTitle?scope.row.RightTitle:'/' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="RightValue">
                        <template slot-scope="scope">
                            <span v-if="scope.row.RightValue==$t('view.招标公告')">
                                <span class="clickText"  @click="Jumps('PreviewDetails', details.sectionId)">{{ $t('view.招标公告') }}</span>
                            </span>
                            <span v-else>{{scope.row.RightValue?scope.row.RightValue:'/'}}</span>
                        </template> 
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!-- 标的物信息 -->
        <div class="whiteBox">
            <div class="title1">{{ $t('view.标的物信息') }}</div>
            <el-table :data="section.sectorList" border header-row-class-name="tableHeader"  max-height="530px" style="width: 940px;margin: 20px 0 10px 0"  v-if="section.sectionType == '0'&&section.engineeringType!=2">
                <el-table-column show-overflow-tooltip align="center" type="index" width="60" :label="$t('view.序号')"/>
                <!-- <el-table-column show-overflow-tooltip align="center" prop="sectorTypeName" :label="$t('view.物资分类')" width="150">
                    <template slot-scope="scope">
                        {{locale=='en'? scope.row.sectorTypeNameEn:locale=='lo'?scope.row.sectorTypeNameLo:scope.row.sectorTypeName}}
                    </template>
                </el-table-column> -->
                <el-table-column show-overflow-tooltip align="center" :label="$t('view.物资名称')">
                    <template slot-scope="scope">
                        {{locale=='en'? scope.row.sectorNameEn:locale=='lo'?scope.row.sectorNameLo:scope.row.sectorName}}
                    </template>
                </el-table-column>
                <el-table-column align="center" show-overflow-tooltip prop="specifications" :label="$t('view.规格')">
                    <template slot-scope="scope">
                        {{locale=='en'? scope.row.specificationsEn:locale=='lo'?scope.row.specificationsLo:scope.row.specifications}}
                    </template>
                </el-table-column>
                <el-table-column align="center" show-overflow-tooltip prop="model" :label="$t('view.型号')">
                    <template slot-scope="scope">
                    {{locale=='en'? scope.row.modelEn:locale=='lo'?scope.row.modelLo:scope.row.model}}
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="sectorNumber" :label="$t('view.需求数量')" width="100"></el-table-column>
                <el-table-column align="center" show-overflow-tooltip prop="sectorUnits" :label="$t('view.计量单位')" width="100">
                    <template slot-scope="scope">
                    {{locale=='en'? scope.row.sectorUnitsEn:locale=='lo'?scope.row.sectorUnitsLo:scope.row.sectorUnits}}
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="remark" :label="$t('view.其他')"></el-table-column>
                <el-table-column align="center"  show-overflow-tooltip :label="$t('view.附件')">
                    <template slot-scope="scope">
                        <span v-if="scope.row.outFileList.length" style="cursor: pointer; line-height: 20px;font-size: 14px;color:#409EFF" @click.stop="handleViewFile(scope.row.outFileList[0].filePath, scope.row.outFileList[0].fileName)">{{ scope.row.outFileList[0].fileName }}</span>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 物资拆分标的物表格 -->
            <el-table v-if="section.sectionType==1" default-expand-all :data="section.sectorList" stripe   header-row-class-name="tableHeader" style="width: 940px;margin: 20px 0 10px 0">
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <el-table :data="props.row.details" border header-row-class-name="tableHeader" style="width: 100%">
                            <el-table-column align="center" show-overflow-tooltip type="index" width="60" :label="$t('view.序号')"/>
                            <!-- <el-table-column align="center" show-overflow-tooltip prop="sectorType" :label="$t('view.物资分类')"></el-table-column> -->
                            <el-table-column align="center" show-overflow-tooltip prop="sectorName" :label="$t('view.物资名称')"></el-table-column>
                            <el-table-column align="center" show-overflow-tooltip prop="remark" :label="$t('view.规格')">
                                <template slot-scope="scope">
                                    {{ locale == 'en' ? scope.row.specificationsEn : locale == 'lo' ? scope.row.specificationsLo:scope.row.specifications}}
                                </template>
                            </el-table-column>
                            <el-table-column align="center" show-overflow-tooltip prop="remark" :label="$t('view.型号')">
                                <template slot-scope="scope">
                                    {{ locale == 'en' ? scope.row.modelEn : locale == 'lo' ? scope.row.modelLo : scope.row.model }}
                                </template>
                            </el-table-column>
                            <el-table-column align="center" show-overflow-tooltip prop="sectorNumber" :label="$t('view.需求数量')"></el-table-column>
                            <el-table-column align="center" show-overflow-tooltip prop="remark" :label="$t('view.计量单位')">
                                <template slot-scope="scope">
                                    {{ locale == 'en' ? scope.row.detailUnitsEn : locale == 'lo' ? scope.row.detailUnitsLo:scope.row.detailUnits}}
                                </template>
                            </el-table-column>
                            <!-- <el-table-column v-if="details.budgetType==2" key="budgetAmount" align="center" show-overflow-tooltip prop="budgetAmount" :label="details.sectorBudgetType==1? $t('view.预算总价'):$t('view.预算单价')">
                                <template slot-scope="scope">
                                    {{scope.row.budgetAmount}}{{moneyUnit}}
                                </template>
                            </el-table-column> -->
                        </el-table>
                    </template>
                </el-table-column>
                <el-table-column align="center" show-overflow-tooltip type="index" width="60" :label="$t('view.序号')"/>
                <el-table-column align="center" show-overflow-tooltip prop="sectorTypeName" :label="$t('view.标段名称')">
                    <template slot-scope="scope">
                        {{locale=='en'? scope.row.sectorNameEn:locale=='lo'?scope.row.sectorNameLo:scope.row.sectorName}}
                    </template>
                </el-table-column>
                <el-table-column align="center" show-overflow-tooltip prop="remark" width="300" :label="$t('view.其他')"></el-table-column>
            </el-table>
              <!-- 总包 -->
            <el-table max-height="500" v-if="section.engineeringType==2" border header-row-class-name="tableHeader" :data="section.sectorList" style="width: 100%;margin-top: 15px;">
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <el-table :data="props.row.details" border header-row-class-name="tableHeader" style="width: 100%">
                            <!-- 物资名称 -->
                            <el-table-column align="center" width="200" show-overflow-tooltip  :label="$t('view.物资名称')">
                                <template slot-scope="scope">
                                    {{locale=='en'? scope.row.sectorNameEn:locale=='lo'?scope.row.sectorNameLo:scope.row.sectorName}}
                                </template>
                            </el-table-column>
                            <!-- 规格 -->
                            <el-table-column align="center" width="150" show-overflow-tooltip  :label="$t('view.规格')">
                                <template slot-scope="scope">
                                    {{locale=='en'? scope.row.specificationsEn:locale=='lo'?scope.row.specificationsLo:scope.row.specifications}}
                                </template>
                            </el-table-column>
                            <!-- 型号 -->
                            <el-table-column align="center" width="150" show-overflow-tooltip  :label="$t('view.型号')">
                                <template slot-scope="scope">
                                    {{locale=='en'? scope.row.modelEn:locale=='lo'?scope.row.modelLo:scope.row.model}}
                                </template>
                            </el-table-column>
                            <!-- 需求数量 -->
                            <el-table-column align="center" show-overflow-tooltip prop="number" :label="$t('view.需求数量')">
                            </el-table-column>
                            <!-- 计量单位 -->
                            <el-table-column align="center" show-overflow-tooltip prop="detailUnits"  :label="$t('view.计量单位')">
                            </el-table-column>
                        <!-- 报价方式 -->
                            <el-table-column align="center" show-overflow-tooltip  :label="$t('view.报价方式')">
                                <template slot-scope="scope">
                                    {{scope.row.quotationMethod==1?$t('view.总价'):$t('view.单价')}}
                                </template>
                            </el-table-column>
                            <!-- 系数名称 -->
                            <el-table-column align="center" show-overflow-tooltip prop="coefficientName"  :label="$t('view.系数名称')">
                            </el-table-column>
                            <!-- 预算 -->
                            <el-table-column align="center" show-overflow-tooltip prop="budgetAmount"  :label="$t('view.预算金额')">
                                <template slot-scope="scope">
                                    {{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')  }}
                                    {{ formatNum(scope.row.budgetAmount) }}
                                </template>
                            </el-table-column>
                            <!-- 附件 -->
                            <el-table-column align="center" show-overflow-tooltip :label="$t('view.附件')">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.outFileList.length" style="cursor: pointer; line-height: 20px;font-size: 14px;color:#409EFF" @click.stop="handleViewFile(scope.row.outFileList[0].filePath, scope.row.outFileList[0].fileName)">{{ scope.row.outFileList[0].fileName }}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </template>
                </el-table-column>
                <el-table-column  align="center" :label="$t('view.标段名称')" width="260">
                    <template slot-scope="scope">
                        {{ locale=='en'? scope.row.sectorNameEn:locale=='lo'?scope.row.sectorNameLo:scope.row.sectorName }}
                    </template>
                </el-table-column>
                <el-table-column align="center" width="150" :label="$t('view.币种')">
                    <template slot-scope="scope">
                        {{getStatus('sys_currency',scope.row.currency)  }}
                    </template>
                </el-table-column>
                <el-table-column align="center" width="150" prop="moneyUnit" :label="$t('view.币种单位')">
                </el-table-column>
                <el-table-column align="center" prop="remark" :label="$t('view.备注')">
                </el-table-column>
            </el-table> 
            <div style="color:#B80008;font-weight: bold; font-size: 16px;margin-bottom: 10px; ">{{$t('view.标的物附件')}}：</div>
            <div class="clickText" v-for="(item,index) in section.sectorFileList" :key="index">
                <!-- <File :file="item"></File> -->
                <span style="line-height: 20px;font-size:14px ;color:#4F62E7" @click.stop="handleViewFile(item.filePath, item.fileName)">{{ item.fileName }}</span>
            </div>
        </div>
        <!-- 投标信息 -->
        <div v-if=" section.biddingType==0" class="whiteBox">
            <div class="title1" style="margin-bottom: 15px">{{$t('view.投标信息')}}</div>
            <div class="item">
                <div>{{ $t('view.公司名称/姓名') }}：</div>
                <div>{{user.supplierName}}</div>
            </div>
            <div class="item">
                <div>{{ $t('view.纳税人识别号') }}：</div>
                <div>{{user.tin}}</div>
            </div>
            <div class="item">
                <div>{{$t("view.联系电话")}}：</div>
                <div>{{ user.phonenumber }}</div>
            </div>
            <div class="item">
                <div>{{$t('view.联系人')}}：</div>
                <div>{{user.nickName}}</div>
            </div>
            <div class="item">
                <div>{{$t('view.电子邮件地址')}}：</div>
                <div>{{ user.email }}</div>
            </div>
        </div>
        <!-- 基础文件提交 -->
        <div class="whiteBox" style="position: relative;" v-if="section.biddingType==1&&
        (details.isQualificationTec==1||details.isQualificationAchievement==1||details.isQualificationAgencyLicense==1||details.isQualificationOther==1)">
            <div class="title1" style="margin-bottom: 15px">{{ $t('view.基础文件提交') }}</div>
            <!-- 未通过 -->
            <div v-if="details.supplierBidStatus==7">
                <div class="mainColor" style="width: 850px;">{{$t('view.未通过原因')}}：{{ details.qualificationReviewRemark }}</div>
            </div>
            <div class="annexList" v-if="details.supplierBaseFile.tecFileList&&details.supplierBaseFile.tecFileList.length">
                <div style="width: 120px;">{{$t('view.技术要求文件')}}：</div>
                <div style="cursor: pointer;color: #4F62E7" @click="handleViewFile(details.supplierBaseFile.tecFileList[0].filePath,details.supplierBaseFile.tecFileList[0].fileName)">{{ details.supplierBaseFile.tecFileList[0].fileName }}</div>
            </div>
            <!-- 供应商技术文件 -->
            <div class="annexList" v-if="details.supplierBaseFile.supTecFileList&&details.isQualificationTec==1">
                <div style="width: 120px;">{{ $t('view.供应商技术文件') }}：</div>
                <div style="flex: 1" v-if="(!details.supplierBaseFile.supTecFileList.length)">
                    <el-upload
                        :action="uploadFileBpm"
                        :data="BpmData"
                        :limit="1"
                         :disabled="details.disabled"
                        :before-upload="beforeAvatarUpload"
                        :class="{'hide': details.supplierBaseFile.supTecFileList.length==1}"
                        :headers="headers" :on-success="(res,file)=>{successList(details.supplierBaseFile.supTecFileList,res,file)}"
                         :on-remove="(res,file)=>{handleRemove('supplierBaseFile.supTecFileList',res,file)}">
                        <img slot="trigger" style="vertical-align: middle;" :src="require('@/assets/BidDetails/icon-upload'+locale+'.png')">
                    </el-upload>
                </div>
                <div v-else style="display: flex;">
                    <File :clsoe="details.supplierBidStatus<5&&details.supplierBidStatus!=3&&!details.disabled" :listName="'supplierBaseFile.supTecFileList'" :file="details.supplierBaseFile.supTecFileList[0]"></File>
                </div>
            </div>
            <!-- 供应商业绩文件 -->
            <div class="annexList" v-if="details.supplierBaseFile.supAchFileList&&details.isQualificationAchievement==1">
                <div style="width: 120px;">{{$t('view.供应商业绩文件')}}：</div>
                <div style="flex: 1" v-if="(!details.supplierBaseFile.supAchFileList.length)">
                    <el-upload
                        :action="uploadFileBpm"
                        :data="BpmData"
                        :limit="1"
                         :disabled="details.disabled"
                        :before-upload="beforeAvatarUpload"
                        :class="{'hide': details.supplierBaseFile.supAchFileList.length==1}"
                        :headers="headers" :on-success="(res,file)=>{successList(details.supplierBaseFile.supAchFileList,res,file)}"
                         :on-remove="(res,file)=>{handleRemove('supplierBaseFile.supAchFileList',res,file)}">
                        <img slot="trigger" style="vertical-align: middle;" :src="require('@/assets/BidDetails/icon-upload'+locale+'.png')">
                    </el-upload>
                </div>
                <div v-else style="display: flex;">
                    <File :clsoe="details.supplierBidStatus<5&&details.supplierBidStatus!=3&&!details.disabled" :listName="'supplierBaseFile.supAchFileList'" :file="details.supplierBaseFile.supAchFileList[0]"></File>
                </div>
            </div>
            <!-- 代理许可 -->
            <div class="annexList" v-if="details.isQualificationAgencyLicense==1">
                <div style="width: 120px;">{{$t('view.代理许可证')}}：</div>
                <div style="flex: 1" v-if="(!details.qualificationAgencyLicenseFileList.length)">
                    <el-upload
                        :action="uploadFileBpm"
                        :data="BpmData"
                        :limit="1"
                        :disabled="details.disabled"
                        :class="{'hide': details.qualificationAgencyLicenseFileList.length==1}"
                        :before-upload="beforeAvatarUpload"
                        :headers="headers" :on-success="(res,file)=>{successList(details.qualificationAgencyLicenseFileList,res,file)}"
                        :on-remove="(res,file)=>{handleRemove('qualificationAgencyLicenseFileList',res,file)}">
                        <img slot="trigger" style="vertical-align: middle;" :src="require('@/assets/BidDetails/icon-upload'+locale+'.png')">
                    </el-upload>
                </div>
                <div v-else style="display: flex;">
                    <File :clsoe="details.supplierBidStatus<8&&details.supplierBidStatus!=6&&!details.disabled" :listName="'qualificationAgencyLicenseFileList'" :file="details.qualificationAgencyLicenseFileList[0]"></File>
                </div>
            </div>
            <!-- 其他 -->
            <div class="annexList" v-if="details.isQualificationOther==1">
                <div style="width: 120px;">{{ locale=='en'? section.qualificationOtherDescribeEn:locale=='lo'?section.qualificationOtherDescribeLo:section.qualificationOtherDescribe }}：</div>
                <div style="flex: 1" v-if="(!details.qualificationOtherFileList.length)">
                    <el-upload
                        :limit="1"
                        :action="uploadFileBpm"
                        :data="BpmData"
                        :disabled="details.disabled"
                        :before-upload="beforeAvatarUpload"
                        :class="{'hide': details.qualificationOtherFileList.length==1}"
                        :headers="headers" :on-success="(res,file)=>{successList(details.qualificationOtherFileList,res,file)}"
                        :on-remove="(res,file)=>{handleRemove('qualificationOtherFileList',res,file)}">
                        <img slot="trigger" style="vertical-align: middle;" :src="require('@/assets/BidDetails/icon-upload'+locale+'.png')">
                    </el-upload>
                </div>
                <div v-else style="display: flex;">
                    <File :clsoe="details.supplierBidStatus<8&&details.supplierBidStatus!=6&&!details.disabled" :listName="'qualificationOtherFileList'" :file="details.qualificationOtherFileList[0]"></File>
                </div>
            </div>
            <!-- 资质状态 -->
             <div style="position: absolute;right: 30px ;top: 10px">
                <!-- 2 基础文件-待提交 3 基础文件-审核中 4 基础文件-驳回 -->
                <img v-if="details.supplierBidStatus==4" :src="require('@/assets/BidDetails/1'+locale+'.png')">
                <img v-if="details.supplierBidStatus==3" :src="require('@/assets/BidDetails/2'+locale+'.png')">
                <img v-if="details.supplierBidStatus>4" :src="require('@/assets/BidDetails/3'+locale+'.png')">
             </div>
            <div v-if="!details.disabled">
                <el-button type="primary" v-if=" details.supplierBidStatus==2||details.supplierBidStatus==4||details.supplierBidStatus==1" size="mini" @click="quotationSupplierBaseFile">{{ $t('view.提交') }}</el-button>
            </div>
        </div>
        <!--资质上传 询价不需要资质上传-->
        <div class="whiteBox" style="position: relative;" v-if="qualificationsShow&&section.biddingType!=1&&
        (details.isQualificationBusinessLicense==1||details.isQualificationAchievement==1||details.isQualificationAgencyLicense==1||details.isQualificationOther==1)
        &&(details.supplierBidStatus>4||section.sectionStauts!=1)">
            <div class="title1" style="margin-bottom: 15px">{{ $t('view.资质上传') }}</div>
            <!-- 未通过 -->
            <div v-if="details.supplierBidStatus==7">
                <div class="mainColor" style="width: 850px;" >{{$t('view.未通过原因')}}：{{ details.qualificationReviewRemark }}</div>
            </div>
            <div class="annexList">
                <div style="width: 100px;">{{$t('view.投标主体')}}：</div>
                <div>{{ user.supplierName }}</div>
            </div>
            <!-- 资质状态 -->
             <div style="position: absolute;right: 30px ;top: 40px" v-if="section.biddingType!=1">
                <!-- 5 资质审核-待提交 6 资质审核-审核中  7 资质审核-驳回 -->
                <img v-if="details.supplierBidStatus==7" :src="require('@/assets/BidDetails/1'+locale+'.png')">
                <img v-if="details.supplierBidStatus==6" :src="require('@/assets/BidDetails/2'+locale+'.png')">
                <img v-if="details.supplierBidStatus>7" :src="require('@/assets/BidDetails/3'+locale+'.png')">
             </div>
             <!-- 营业执照 -->
            <div class="annexList" v-if="details.isQualificationBusinessLicense==1">
                <div style="width: 100px;">{{$t('view.营业执照')}}：</div>
                <div style="flex: 1" v-if="(!details.qualificationBusinessLicenseFileList.length)">
                    <el-upload
                        :action="uploadFileBpm"
                        :data="BpmData"
                        :limit="1"
                        style="display: flex;align-items: center;"
                         :disabled="details.disabled"
                        :before-upload="beforeAvatarUpload"
                        :class="{'hide': details.qualificationBusinessLicenseFileList.length==1}"
                        :headers="headers" :on-success="(res,file)=>{successList(details.qualificationBusinessLicenseFileList,res,file)}"
                         :on-remove="(res,file)=>{handleRemove('qualificationBusinessLicenseFileList',res,file)}">
                        <img slot="trigger" style="vertical-align: middle;" :src="require('@/assets/BidDetails/icon-upload'+locale+'.png')">
                        <span slot="tip" style="margin-left: 10px;display: block;" class="el-upload__tip">{{ $t('view.上传营业执照副本，仅用于资质审核') }}</span>
                    </el-upload>
                </div>
                <div v-else style="display: flex;">
                    <File :clsoe="details.supplierBidStatus<8&&details.supplierBidStatus!=6&&!details.disabled" :listName="'qualificationBusinessLicenseFileList'" :file="details.qualificationBusinessLicenseFileList[0]"></File>
                </div>
            </div>
            <!-- 业绩 -->
            <div class="annexList" v-if="details.isQualificationAchievement==1">
                <div style="width: 100px;">{{$t('view.业绩')}}：</div>
                <div style="flex: 1" v-if="(!details.qualificationAchievementFileList.length)">
                    <el-upload
                        :action="uploadFileBpm"
                        :data="BpmData"
                        :limit="1"
                         style="display: flex;align-items: center;"
                        :disabled="details.disabled"
                        :before-upload="beforeAvatarUpload"
                        :class="{'hide':details.qualificationAchievementFileList.length==1}"
                        :headers="headers" :on-success="(res,file)=>{successList(details.qualificationAchievementFileList,res,file)}"
                        :on-remove="(res,file)=>{handleRemove('qualificationAchievementFileList',res,file)}">
                        <img slot="trigger" style="vertical-align: middle;" :src="require('@/assets/BidDetails/icon-upload'+locale+'.png')">
                        <span slot="tip" style="margin-left: 10px;display: block" class="el-upload__tip">{{$t('view.上传以往业绩合同附件，仅用于资质审核')}}</span>
                    </el-upload>
                </div>
                <div v-else style="display: flex;">
                    <File :clsoe="details.supplierBidStatus<8&&details.supplierBidStatus!=6&&!details.disabled" :listName="'qualificationAchievementFileList'" :file="details.qualificationAchievementFileList[0]"></File>
                </div>
            </div>
            <!-- 代理许可 -->
            <div class="annexList" v-if="details.isQualificationAgencyLicense==1">
                <div style="width: 100px;">{{$t('view.代理许可证')}}：</div>
                <div style="flex: 1" v-if="(!details.qualificationAgencyLicenseFileList.length)">
                    <el-upload
                        :action="uploadFileBpm"
                        :data="BpmData"
                        :limit="1"
                        :disabled="details.disabled"
                        :class="{'hide': details.qualificationAgencyLicenseFileList.length==1}"
                        :before-upload="beforeAvatarUpload"
                        :headers="headers" :on-success="(res,file)=>{successList(details.qualificationAgencyLicenseFileList,res,file)}"
                        :on-remove="(res,file)=>{handleRemove('qualificationAgencyLicenseFileList',res,file)}">
                        <img slot="trigger" style="vertical-align: middle;" :src="require('@/assets/BidDetails/icon-upload'+locale+'.png')">
                    </el-upload>
                </div>
                <div v-else style="display: flex;">
                    <File :clsoe="details.supplierBidStatus<8&&details.supplierBidStatus!=6&&!details.disabled" :listName="'qualificationAgencyLicenseFileList'" :file="details.qualificationAgencyLicenseFileList[0]"></File>
                </div>
            </div>
            <!-- 其他 -->
            <div class="annexList" v-if="details.isQualificationOther==1">
                <div style="width: 100px;">{{ locale=='en'? section.qualificationOtherDescribeEn:locale=='lo'?section.qualificationOtherDescribeLo:section.qualificationOtherDescribe }}：</div>
                <div style="flex: 1" v-if="(!details.qualificationOtherFileList.length)">
                    <el-upload
                        :limit="1"
                        :action="uploadFileBpm"
                        :data="BpmData"
                        :disabled="details.disabled"
                        :before-upload="beforeAvatarUpload"
                        :class="{'hide': details.qualificationOtherFileList.length==1}"
                        :headers="headers" :on-success="(res,file)=>{successList(details.qualificationOtherFileList,res,file)}"
                        :on-remove="(res,file)=>{handleRemove('qualificationOtherFileList',res,file)}">
                        <img slot="trigger" style="vertical-align: middle;" :src="require('@/assets/BidDetails/icon-upload'+locale+'.png')">
                    </el-upload>
                </div>
                <div v-else style="display: flex;">
                    <File :clsoe="details.supplierBidStatus<8&&details.supplierBidStatus!=6&&!details.disabled" :listName="'qualificationOtherFileList'" :file="details.qualificationOtherFileList[0]"></File>
                </div>
            </div>
            <div v-if="!details.disabled">
                <el-button type="primary" v-if=" details.supplierBidStatus==5||details.supplierBidStatus==7||details.supplierBidStatus==1" size="mini" @click="signupSubmitQualification">{{$t('view.提交')}}</el-button>
            </div>
        </div>
        <!-- 投标保证金 标书 -->
        <!-- 8 缴费-待提交  9 缴费-审核中  10 缴费-驳回 -->
         <div class="whiteBox" v-if="details.supplierBidStatus>7 &&section.biddingType==0&&receivingAccountList.length">
            <div v-for="(item,index) in receivingAccountList" :key="index">
                <div class="title1" style="margin-bottom: 15px">{{ item.type!=1?$t('view.投标保证金'):$t('view.标书费') }}</div>
                <div class="box" style="align-items: center;line-height: 20px;" v-if="details.supplierBidStatus==9||details.supplierBidStatus>10">
                    <img src="../../../assets/BidDetails/icon-money.png">
                    <div  style="width: 260px;padding-left:20px;">
                        <div style="color: #333333;font-size: 18px;margin-bottom: 20px;">{{$t('view.已缴纳')}}{{ item.type!=1?$t('view.保证金'):$t('view.标书费')}} </div>
                        <div style="color: #FFB533;">{{getStatus('sys_currency',item.currency,'remark')}}<span style="margin-left: 5px">{{formatNum(item.money)}}</span></div>
                    </div>
                    <div style="width: 200px;display: block;text-align: center" class="lineItem">
                        <div style="margin-bottom: 20px;margin-top: 10px;">{{ $t('view.缴费日期') }}</div>
                        <div>{{ item.paymentDate }}</div>
                    </div>
                    <div style="flex: 1; display: block;text-align: center" class="lineItem">
                        <div style="margin-bottom: 20px;margin-top: 10px;">{{ $t('view.缴费凭证') }}</div>
                        <div  v-if="item.fileList.length">
                            <div v-if="item.fileList[0].type=='jpg'||item.fileList[0].type=='png'||item.fileList[0].type=='jpeg'"
                            class="clickText single-line" style="width: 290px; color: #4F62E7" :title="item.fileList[0].fileName" @click="viewPicture(item.fileList[0].filePath)">{{item.fileList[0].fileName}}</div>
                            <div v-else class="clickText single-line" style="width: 290px; color: #4F62E7" :title="item.fileList[0].fileName" @click="handleViewFile1(item.fileList[0].filePath)">{{item.fileList[0].fileName}}</div>
                        </div>
                    </div>
                    <div class="mainColor" style="width: 100px;font-weight: 600;">{{details.supplierBidStatus==9?$t('view.审核中'):details.supplierBidStatus>10?$t('view.已缴纳'):'' }}</div>
                </div>
                <div  v-if="details.supplierBidStatus==8||details.supplierBidStatus==10">
                    <div  v-if="details.supplierBidStatus==10" style="margin-bottom: 20px">
                        <span class="mainColor" style="font-weight: 600;font-size: 20px;">{{$t('view.缴费未通过')}}</span>
                        <span style="margin-left: 10px; font-size: 14px;color: #909399;">{{details.marginReviewRemark}}</span>
                    </div>
                    <div class="box" style="align-items: center;line-height: 20px;">
                        <img src="../../../assets/BidDetails/icon-money.png">
                        <div style="width: 300px;padding-left:20px;">
                            <div style="color: #333333;font-size: 18px;margin-bottom: 20px;">{{$t('view.待缴纳')}}{{ item.type!=1?$t('view.保证金'):$t('view.标书费') }}：<span style="color: #FFB533;">{{getStatus('sys_currency',item.currency,'remark')}}{{ formatNum(item.money) }}</span></div>
                            <div>
                                <span style="color: #999999;font-size: 14px;">{{ $t('view.倒计时') }}</span>
                                <span style="margin-left: 10px" v-if="details.supplierBidStatus<20&&details.supplierBidStatus!=-1&&!details.disabled" class="mainColor">{{ item.timeList }}</span>
                                <span style="margin-left: 10px" v-else class="mainColor">00:00:00</span>
                            </div>
                        </div>
                        <div style="width: 300px">
                            <div class="lineItem" style="margin-bottom: 20px;margin-top: 10px;">{{$t('view.账号名称')}}：<span>{{item.bankAccount}}</span></div>
                            <div class="lineItem">{{$t('view.对方账户')}}：<span>{{item.bankAccountName}}</span></div>
                        </div>
                        <div style="width: 250px;">
                            <!-- 占位 -->
                            <div class="lineItem" style="width: 10px;height: 20px;margin-top: 10px;"></div>
                            <div class="lineItem">{{$t('view.开户行')}}：<span>{{item.openAccountBank}}</span></div>
                        </div>
                    </div>
                    <div class="box" style="align-items: center;flex-direction:row-reverse;line-height: 20px;">
                        <div style="width: 250px;">
                            <!-- 占位 -->
                            <div class="lineItem" style="width: 10px;height: 20px;margin-top: 10px;"></div>
                            <div class="lineItem">{{$t('view.缴费结束时间')}}：<span>{{item.paymentDeadline}}</span></div>
                        </div>
                        <div style="width: 300px">
                            <div class="lineItem" style="margin-bottom: 20px;margin-top: 10px;">{{$t('view.缴费方式')}}：<span>{{ $t('view.对公转账') }}</span></div>
                            <!-- <div class="lineItem">缴费开始时间：<span></span></div> -->
                        </div>
                        <div style="flex: 1;" class="single-line">
                            <el-upload  :limit="1"  :action="uploadFileBpm"
                            :data="BpmData" :before-upload="beforeAvatarUpload"
                                :class="{'hide': item.fileList.length==1}"
                                :disabled="details.disabled"
                                :headers="headers" :on-success="(res,file)=>{successList(item.fileList,res,file)}"
                                :on-remove="(res,file)=>{handleRemoveClear(index,res,file)}">
                                <div slot="trigger" class="payBtn" style="">{{ $t('view.缴费') }}</div>
                            </el-upload>
                            <div class="lineItem" :style="{width: '10px',height:item.fileList.length==1? '40px':'10px'}"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="!details.disabled">
                <div v-if="details.supplierBidStatus==8||details.supplierBidStatus==10" style="text-align: center;margin-top: 10px;"><el-button size="mini" @click="signupSubmitPayment" type="primary">{{$t('view.提交')}}</el-button></div>
            </div>
        </div>

        <!-- 招标文件  isBiddingCommitFile 是否勾选了上传标书文件-->
        <div class="whiteBox" v-if="details.supplierBidStatus>10 &&section.biddingType==0&&section.isBiddingCommitFile!='0'">
            <div class="title1" style="margin-bottom: 15px;">{{ $t('view.招标文件') }}</div>
            <div class="box" style="line-height: 20px;display: block">
                <div class="clickText" v-for="item in section.fileList" :key="item.id" @click="handleViewFile(item.filePath,item.fileName)">
                    <File :file="item"></File>
                </div>
            </div>
        </div>
        <!-- 投标文件 -->
        <div  class="whiteBox" v-if="details.supplierBidStatus>10 &&section.biddingType==0&&section.isBiddingCommitFile!='0'">
            <div class="title1" style="margin-bottom: 15px;">{{$t('view.投标文件')}}
                <span class="redtext" style="margin-left: 10px" v-if="details.supplierBidStatus==11&&!details.disabled">{{ $t('view.未提交') }}</span>
            </div>
            <div v-if="details.supplierBidStatus==11||details.supplierBidStatus==13">
                <div class="box" style="line-height: 20px;">
                    <div style="width:200px;margin-bottom: 10px;  font-size: 14px;">{{ $t('view.倒计时') }}:
                        <span style="margin-left: 10px; color: #909399;" v-if="details.supplierBidStatus<20&&details.supplierBidStatus!=-1&&!details.disabled" class="mainColor">{{ section.timeList }}</span>
                        <span style="margin-left: 10px" class="mainColor"  v-else>00:00:00</span>
                    </div> 
                    <div class="lineItem">{{$t('view.投标文件类型')}}：
                        <span style="color:#333333" v-if="section.isCommitTechnicalFile==1">{{ $t('view.技术文件')}}</span>
                        <span style="color:#333333" v-if="section.isCommitBusinessFile==1"><span v-if="section.isCommitTechnicalFile==1&&section.isCommitBusinessFile==1">、</span> {{ $t('view.商务文件')}}</span>
                    </div>
                    <div class="lineItem" style="margin:0 50px 10px 50px">{{$t('view.递交开始时间')}}：<span>{{ section.bidFileStartTime }}</span></div>
                    <div class="lineItem">{{$t('view.递交结束时间')}}：<span>{{ section.bidFileEndTime }}</span></div>
                </div>
                <div class="box" style="line-height: 20px;display: block" v-if="section.timeList!=$t('view.已超时')">
                    <el-upload    :action="uploadFileBpm"
                        :data="BpmData"
                        :disabled="details.disabled"
                        ref="upload1"
                        :headers="headers" :on-success="signupSubmitSupplierBidFile">
                        <el-button size="mini" type="primary" @click.stop="fileUploadFile">{{ $t('view.上传投标文件') }}</el-button>
                        <div slot="tip" class="el-upload__tip"></div>
                    </el-upload>
                    <div style="color: #909399;font-size: 14px;line-height:35px">{{$t('view.请点击按钮上传投标文件，可以在投标截止时问前，修改或撤回投标文件')}}</div>
                    <div style="color: #909399;font-size: 14px;line-height:35px">{{$t('view.如果要重新上传投标文件，必须将上次上传的投标文件撤回才可重新上传')}}</div>
                    <div style="color: #909399;font-size: 14px;line-height:35px">{{$t('view.请充分考虑到传送的时间和自身的网络情况，在投标截止时间前完成投标，逾时传这会被判断为逾期送达')}}</div>
                </div>
            </div>
            <div v-if="details.supplierBidFileList">
                <el-table border header-row-class-name="tableHeader" :data="details.supplierBidFileList" style="width: 100%">
                    <el-table-column align="center" type="index" width="60" :label="$t('view.序号')"></el-table-column>
                    <el-table-column align="center" prop="fileName" show-overflow-tooltip :label="$t('view.文件名称')"></el-table-column>
                    <el-table-column align="center" prop="date" show-overflow-tooltip :label="$t('view.投标单位')" >
                        <template> {{ user.supplierName }} </template>
                    </el-table-column>
                    <el-table-column align="center" width="100" prop="date" show-overflow-tooltip :label="$t('view.投标负责人')">
                        <template> {{ user.nickName }} </template>
                    </el-table-column>
                    <el-table-column align="center" prop="createTime" width="150" show-overflow-tooltip :label="$t('view.上传日期')" ></el-table-column>
                    <el-table-column align="center" prop="date" width="150" show-overflow-tooltip :label="$t('view.投标文件状态')" >
                        <template slot-scope="scope">
                            {{getStatus('sys_supplier_margin_status',scope.row.status)}}
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="150" show-overflow-tooltip :label="$t('view.操作')" >
                        <template slot-scope="scope">
                            <span class="clickText" @click="reasons" v-if="scope.row.status==2" style="margin-right: 20px">{{ $t('view.查看原因') }}</span>
                            <span class="clickText" @click="handleViewFile1(scope.row.filePath,scope.row.fileName)">{{ $t('view.下载') }}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-button v-if="details.supplierBidStatus==12" size="mini" plain type="primary" style="margin:10px 0;" @click="signupCancelSupplierBidFile">{{$t('view.撤回投标文件')}}</el-button>
                <div style="color: #909399;font-size: 14px;line-height:35px;margin:10px 0;">{{ $t('view.已上传的投标文件撤销成功后，请及时重新上传投标文件。务必保证操作历史中最新的为上传成功的记录。') }}</div>
            </div>

        </div>
        
      
         <!-- 保证金退还 -->
         <div class="whiteBox" v-if="(RefundDeposit.status==6||RefundDeposit.status==5||RefundDeposit.status==4)&& section.biddingType==0 ">
            <div class="title1" style="margin-bottom: 15px;">{{$t('view.退还保证金')}}</div>
            <div class="box" style="align-items: center;line-height: 20px;">
                <img src="../../../assets/BidDetails/icon-money.png">
                <div  style="width: 160px;padding-left:20px;">
                    <div style="color: #333333;font-size: 18px;margin-bottom: 20px;">{{ RefundDeposit.status==5?$t('view.待退还保证金'): $t('view.已退还保证金')}}  </div>
                    <div style="color: #FFB533;">{{getStatus('sys_currency',RefundDeposit.currency,'remark')}}<span style="margin-left: 5px">{{formatNum(RefundDeposit.money)}}</span></div>
                </div>
                <div style="width: 200px;display: block;text-align: center" class="lineItem">
                    <div style="margin-bottom: 20px;margin-top: 10px;">{{ $t('view.缴费日期') }}</div>
                    <div>{{ RefundDeposit.paymentDate }}</div>
                </div>
                <div style="flex: 1; display: block;text-align: center" class="lineItem">
                    <div style="margin-bottom: 20px;margin-top: 10px;">{{$t('view.退费凭证')}}</div>
                    <div v-if="RefundDeposit.fileList.length">
                        <div v-if="RefundDeposit.fileList[0].type=='jpg'||RefundDeposit.fileList[0].type=='png'||RefundDeposit.fileList[0].type=='jpeg'" class="clickText single-line" style="width: 280px; color: #4F62E7" :title="RefundDeposit.fileList[0].fileName" @click="viewPicture(RefundDeposit.fileList[0].filePath)">{{RefundDeposit.fileList[0].fileName}}</div>
                        <div v-else class="clickText single-line" style="width: 280px; color: #4F62E7" :title="RefundDeposit.fileList[0].fileName" @click="handleViewFile1(RefundDeposit.fileList[0].filePath)">{{RefundDeposit.fileList[0].fileName}}</div>
                    </div>
                </div>
                <div v-if="RefundDeposit.status==6"  style="text-align: center;width: 200px;">
                    <el-button plain type="primary" @click="refundConfirm">{{ $t('view.确认退还') }}</el-button>
                    <!-- v-if="RefundDeposit.timeList!='已超时'" -->
                    <div style="font-size: 14px;color:#909399;margin-left:20px;margin-top:10px;">{{ $t('view.确认退还倒计时') }}<span class="mainColor">{{ RefundDeposit.timeList }}</span> </div>
                </div>
            </div>

        </div>
        <!-- 报价说明 -->
        <div class="whiteBox" style="position: relative" v-if="details.isQualificationQuotes==1&&details.supplierBidStatus>15&&section.biddingType==1">
            <div class="title1" style="margin-bottom: 15px;">{{ $t('view.报价说明') }}</div>
            <!-- 资质状态 -->
            <div style="position: absolute;right: 30px ;top: 0px">
                <img v-if="details.supplierBidStatus==18" :src="require('@/assets/BidDetails/1'+locale+'.png')">
                <img v-if="details.supplierBidStatus==17" :src="require('@/assets/BidDetails/2'+locale+'.png')">
                <img v-if="details.supplierBidStatus>18" :src="require('@/assets/BidDetails/3'+locale+'.png')">
             </div>
            <div class="annexList">
                <div style="width: 100px;">{{$t('view.报价说明文件')}}：</div>
                <div style="flex: 1" v-if="(!details.quotesNoteFileList.length)">
                    <el-upload
                        :action="uploadFileBpm"
                        :data="BpmData"
                        :limit="1"
                        :before-upload="beforeAvatarUpload"
                         style="display: flex;align-items: center;"
                        :class="{'hide': details.quotesNoteFileList.length==1}"
                        :headers="headers" :on-success="(res,file)=>{successList(details.quotesNoteFileList,res,file)}"
                            :on-remove="(res,file)=>{handleRemove('quotesNoteFileList',res,file)}">
                        <img slot="trigger" style="vertical-align: middle;" :src="require('@/assets/BidDetails/icon-upload'+locale+'.png')">
                        <span slot="tip" style="margin-left: 10px;display: block" class="el-upload__tip">{{ $t('view.用于上传盖章版报价说明文件，请在最后一次报价结束后上传') }}</span>
                    </el-upload>
                </div>
                <div v-else style="display: flex;">
                    <File :clsoe="details.supplierBidStatus==16||details.supplierBidStatus==18" listName="quotesNoteFileList" :file="details.quotesNoteFileList[0]"></File>
                </div>
            </div>
            <div v-if="details.supplierBidStatus==16||details.supplierBidStatus==18">
                <el-button type="primary" size="mini" @click="signuSubmitQuotesFile">{{ $t('view.提交') }}</el-button>
            </div>
        </div>
        <!-- details.supplierBidStatus==20&&section.systemId!='indonesianSupplyChain'&&details.sectionId!='3826' -->
        <!-- 投标结果 -->
        <div class="whiteBox" v-if="false">
            <div class="title1" style="margin-bottom: 15px;">{{$t('view.项目公示')}}</div>
            <div v-if="BiddingResultsList.isWinningBid==0" style="position: relative;">
                <el-table border :key="Math.random()" header-row-class-name="tableHeader" max-height="500" :data="BiddingResultsList.quotes" style="width:700px" >
                    <el-table-column type="index" width="60" align="center" :label="$t('view.序号')"></el-table-column> 
                    <el-table-column prop="sectorName" align="center" show-overflow-tooltip :label="$t('view.物资/项目')"></el-table-column>
                    <el-table-column prop="totalPrice" align="center" show-overflow-tooltip :label="$t('view.报价')+'（'+moneyUnit+'）'">
                        <template slot-scope="scope">
                                {{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')  }}{{ formatNum(scope.row.totalPrice) }}
                        </template>
                    </el-table-column>
                </el-table>
                <img :src="require('@/assets/BidDetails/4'+locale+'.png')" style="position: absolute;right:0;top: -30px">
            </div>
            <div v-else style="position: relative;">
                <!-- 中标 -->
                <div style="width:700px;line-height: 20px;font-size:14px;color: #606266;line-height:30px;" v-if="BiddingResultsList.bidAwardManage">
                    <div style="">{{ BiddingResultsList.bidAwardManage.supplierName }}:</div>
                    <div>{{$t('view.你方')}}{{ BiddingResultsList.bidAwardManage.supplierBidFileDateTime }} {{$t('view.所递交的')}}{{BiddingResultsList.bidAwardManage.supplierBidFileName}} {{$t('view.投标文件已被我方接受，被确定为中标人。')}}</div>
                    <div v-if="this.locale=='zh'">{{ $t('view.中标价') }}: {{convertCurrency(BiddingResultsList.bidAwardManage.price,moneyUnit)}} ({{ $t('view.小写') }}: {{formatNum(BiddingResultsList.bidAwardManage.price)}} {{ moneyUnit }})</div>
                    <div v-else>{{ $t('view.中标价') }}: {{new Intl.NumberFormat('en-US',{useGrouping: true}).format(BiddingResultsList.bidAwardManage.price)}} {{ moneyUnit }}</div>

                    <div>{{$t('view.请你方在接到本通知书后的30日内到')}} {{BiddingResultsList.bidAwardManage.organization}}{{ $t('view.与我方签订') }} {{ this.locale=='en'? section.sectionNameEn:this.locale=='lo'?section.sectionNameLo:section.sectionName }}{{ $t('view.合同协议书') }}</div>
                    <el-table :key="Math.random()" border header-row-class-name="tableHeader" style="margin:10px 0" :data="BiddingResultsList.bidAwardManage.manageDetails" >
                        <el-table-column type="index" width="60" align="center" :label="$t('view.序号')"></el-table-column> 
                        <el-table-column prop="sectorName" align="center" show-overflow-tooltip :label="$t('view.物资/项目')"></el-table-column>
                        <el-table-column prop="quotesTotalPrice" align="center" show-overflow-tooltip :label="$t('view.报价')+'（'+moneyUnit+'）'">
                            <template slot-scope="scope">
                                    {{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')  }}{{ formatNum(scope.row.quotesTotalPrice) }}
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <!-- <div v-if="section.engineeringType==2&&section.successfulBidderMethod==1" style="font-size:14px;color: #606266;">{{$t('view.中标明细')}}</div> -->
                <!-- 中标明细 -->
                <!-- <el-table :key="Math.random()" max-height="500" v-if="section.engineeringType==2&&section.successfulBidderMethod==1" border header-row-class-name="tableHeader" :data="BiddingResultsList.winningBidQuotesList" style="width: 100%;margin-top: 15px;">
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <el-table :data="props.row.details"  border header-row-class-name="tableHeader" style="width: 100%">
                                <el-table-column align="center"   :label="$t('view.物资名称')">
                                    <template slot-scope="scope">
                                        <div>{{ ++scope.$index }}、{{ locale=='en'? scope.row.sectorNameEn:locale=='lo'?scope.row.sectorNameLo:scope.row.sectorName }}</div>
                                        <div>{{ $t('view.数量') }}：{{ scope.row.number }}{{ scope.row.detailUnits }}</div> 
                                        <div>{{$t('view.报价方式')}}：{{scope.row.quotationMethod==1?$t('view.总价'):$t('view.单价')}}（{{scope.row.moneyUnit}}/{{scope.row.detailUnits}}）</div>
                                        <div class="mainColor" v-if="scope.row.budgetAmount&&section.budgetType==2">【{{$t('view.限价')}}：{{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')}}{{formatNum(scope.row.budgetAmount)}}（{{scope.row.moneyUnit}}/{{scope.row.detailUnits}}）】</div>
                                    </template>
                                </el-table-column>
                                <el-table-column align="center" prop="detailPrice" :label="section.isTax=='1'? $t('view.报价（含税）'):$t('view.报价')">
                                </el-table-column>
                                <el-table-column align="center" v-if="section.isTax=='1'" :label="$t('view.税率')">
                                    <template slot-scope="scope">
                                        <span>{{getStatus('sys_tax_rate',scope.row.taxRate)  }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column align="center"   :label="$t('view.系数')">
                                    <template slot-scope="scope">
                                        <div v-if="scope.row.coefficientName">
                                            <span>{{ scope.row.coefficientName }}</span>
                                            <div>{{ scope.row.coefficient }}</div>
                                        </div>
                                        <div v-else>/</div>
                                    </template>
                                </el-table-column>
                                <el-table-column align="center"  :label="section.isTax=='1'? $t('view.总价（含税）') :$t('view.总价')">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.quotationMethod==1" >{{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')}}{{formatNum(scope.row.detailPrice?scope.row.detailPrice:0) }}</span>
                                        <span v-else>{{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')}}{{ formatNum((scope.row.detailPrice* scope.row.number).toFixed(4))}}</span>
                                    </template> 
                                </el-table-column>
                            </el-table>
                        </template>
                    </el-table-column>
                    <el-table-column  align="center" :label="$t('view.标段名称')" width="260">
                        <template slot-scope="scope">
                            {{ locale=='en'? scope.row.sectorNameEn:locale=='lo'?scope.row.sectorNameLo:scope.row.sectorName }}
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="150" :label="$t('view.币种')">
                        <template slot-scope="scope">
                            {{getStatus('sys_currency',scope.row.currencyTypeId)  }}
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="150" prop="moneyUnit" :label="$t('view.币种单位')">
                    </el-table-column>
                    <el-table-column align="center" width="150" prop="totalPrice"  :label="section.isTax=='1'? $t('view.总价（含税）') :$t('view.总价')">
                        <template  slot-scope="scope">
                            <span class="mainColor">{{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')}}{{ formatNum(scope.row.totalPrice) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="remarks1" :label="$t('view.备注')">
                    </el-table-column>
                </el-table>  -->
                <img :src="require('@/assets/BidDetails/5'+locale+'.png')" style="position: absolute;right: 0 ;top: 0">
            </div>
            <!-- <el-button size="mini" style="margin:20px 0 10px 0" type="primary" v-if="details.supplierBidStatus==20" @click="appealShow=true">申诉提问</el-button> -->
        </div>
         <!-- 保证金退还 -->
         <div class="whiteBox" v-if="(RefundDeposit.status==6||RefundDeposit.status==5||RefundDeposit.status==4)&& section.biddingType==0 ">
            <div class="title1" style="margin-bottom: 15px;">{{$t('view.退还保证金')}}</div>
            <div class="box" style="align-items: center;line-height: 20px;">
                <img src="../../../assets/BidDetails/icon-money.png">
                <div  style="width: 160px;padding-left:20px;">
                    <div style="color: #333333;font-size: 18px;margin-bottom: 20px;">{{ RefundDeposit.status==5?$t('view.待退还保证金'): $t('view.已退还保证金')}}  </div>
                    <div style="color: #FFB533;">{{getStatus('sys_currency',RefundDeposit.currency,'remark')}}<span style="margin-left: 5px">{{formatNum(RefundDeposit.money)}}</span></div>
                </div>
                <div style="width: 200px;display: block;text-align: center" class="lineItem">
                    <div style="margin-bottom: 20px;margin-top: 10px;">{{ $t('view.缴费日期') }}</div>
                    <div>{{ RefundDeposit.paymentDate }}</div>
                </div>
                <div style="flex: 1; display: block;text-align: center" class="lineItem">
                    <div style="margin-bottom: 20px;margin-top: 10px;">{{$t('view.退费凭证')}}</div>
                    <div v-if="RefundDeposit.fileList.length">
                        <div v-if="RefundDeposit.fileList[0].type=='jpg'||RefundDeposit.fileList[0].type=='png'||RefundDeposit.fileList[0].type=='jpeg'" class="clickText single-line" style="width: 280px; color: #4F62E7" :title="RefundDeposit.fileList[0].fileName" @click="viewPicture(RefundDeposit.fileList[0].filePath)">{{RefundDeposit.fileList[0].fileName}}</div>
                        <div v-else class="clickText single-line" style="width: 280px; color: #4F62E7" :title="RefundDeposit.fileList[0].fileName" @click="handleViewFile1(RefundDeposit.fileList[0].filePath)">{{RefundDeposit.fileList[0].fileName}}</div>
                    </div>
                </div>
                <div v-if="RefundDeposit.status==6"  style="text-align: center;width: 200px;">
                    <el-button plain type="primary" @click="refundConfirm">{{ $t('view.确认退还') }}</el-button>
                    <!-- v-if="RefundDeposit.timeList!='已超时'" -->
                    <div style="font-size: 14px;color:#909399;margin-left:20px;margin-top:10px;">{{ $t('view.确认退还倒计时') }}<span class="mainColor">{{ RefundDeposit.timeList }}</span> </div>
                </div>
            </div>

        </div>
        <!-- 报价记录 -->
        <div  class="whiteBox" v-if="details.supplierBidStatus>14">
            <div class="title1" style="margin-bottom: 15px;">{{ $t('view.报价记录') }}</div>
            <div v-for="(item,index) in HistoricalQuotation" :key="index" style="position: relative;">
                <div class="Round">{{$t('view.第')}}{{arabicToChinese(item.quotesCount)  }}{{ $t('view.轮报价') }}</div>
                <!-- position: absolute;right: 10px;top:0px; -->
                <div style="text-align: center;" @click="item.show=!item.show">{{item.show?$t('view.收起'):$t('view.展开') }}</div>
                <el-table v-if="section.engineeringType!=2&&item.show" border header-row-class-name="tableHeader" :data="item.quotesList" style="width: 930px">
                    <el-table-column fixed type="expand" v-if="section.sectionType==1">
                        <template slot-scope="props">
                            <el-table :data="props.row.details"  border header-row-class-name="tableHeader" style="width: 100%">
                                <el-table-column align="center" show-overflow-tooltip type="index" width="60" :label="$t('view.序号')"/>
                                <el-table-column align="center" show-overflow-tooltip prop="sectorName" :label="$t('view.物资名称')"></el-table-column>
                                <el-table-column align="center" show-overflow-tooltip prop="remark" :label="$t('view.规格')">
                                    <template slot-scope="scope">
                                        {{ locale == 'en' ? scope.row.specificationsEn : locale == 'lo' ? scope.row.specificationsLo:scope.row.specifications}}
                                    </template>
                                </el-table-column>
                                <el-table-column align="center" show-overflow-tooltip prop="remark" :label="$t('view.型号')">
                                    <template slot-scope="scope">
                                        {{ locale == 'en' ? scope.row.modelEn : locale == 'lo' ? scope.row.modelLo : scope.row.model }}
                                    </template>
                                </el-table-column>
                                <el-table-column align="center" show-overflow-tooltip prop="sectorNumber" :label="$t('view.需求数量')"></el-table-column>
                                <el-table-column align="center" show-overflow-tooltip prop="remark" :label="$t('view.计量单位')">
                                    <template slot-scope="scope">
                                        {{ locale == 'en' ? scope.row.detailUnitsEn : locale == 'lo' ? scope.row.detailUnitsLo:scope.row.detailUnits}}
                                    </template>
                                </el-table-column>
                                <!-- <el-table-column v-if="details.budgetType==2" key="budgetAmount" align="center" show-overflow-tooltip prop="budgetAmount" :label="details.sectorBudgetType==1? $t('view.预算总价'):$t('view.预算单价')">
                                    <template slot-scope="scope">
                                        {{scope.row.budgetAmount}}{{moneyUnit}}
                                    </template>
                                </el-table-column> -->
                            </el-table>
                        </template>
                    </el-table-column>
                    <el-table-column fixed align="center" type="index" width="60" :label="$t('view.序号')"/>
                    <el-table-column header-align="center" fixed width="300" v-if="section.sectionType!=1"  :label="$t('view.标的物信息')">
                        <template slot-scope="scope">
                            <div class="twoLine" style="max-height: 50px;"><span style="color: #9FA6AC;">{{$t('view.物料名称')}}：</span>  {{ locale=='en'? scope.row.sectorNameEn:locale=='lo'?scope.row.sectorNameLo:scope.row.sectorName }}</div>
                            <div v-if="section.budgetType==2&&section.isYuanJu!=1">
                                <span style="color: #9FA6AC;">{{ details.sectorBudgetType==1? $t('view.预算总价'):$t('view.预算单价')}}：</span>
                               {{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')  }}{{ formatNum(scope.row.budgetAmount) }}{{ moneyUnit }}
                            </div>
                            <div v-if="section.isYuanJu==1"><span style="color: #9FA6AC;">{{$t('view.预算金额')}}：</span>
                                {{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')  }}{{formatNum(section.biddingTradeType==1?scope.row.maxPrice :scope.row.minPrice)  }}{{ moneyUnit }}
                            </div>   
                            <div><span style="color: #9FA6AC;">{{$t('view.需求数量')}}：</span> {{ scope.row.number }} / {{scope.row.unit }}</div>
                            <div><span style="color: #9FA6AC;">{{$t('view.规格')}}：</span> {{ locale == 'en' ? scope.row.specificationsEn : locale == 'lo' ? scope.row.specificationsLo:scope.row.specifications}}</div>
                            <div><span style="color: #9FA6AC;">{{$t('view.型号')}}：</span> {{ locale == 'en' ? scope.row.modelEn : locale == 'lo' ? scope.row.modelLo : scope.row.model }}</div>
                            <div class="single-line" :title="scope.row.sectorRemark" ><span style="color: #9FA6AC;">{{$t('view.其他')}}：</span>{{scope.row.sectorRemark?scope.row.sectorRemark:'-' }}</div>
                            <div class="single-line" v-if="scope.row.outFileList&&scope.row.outFileList.length"><span style="color: #9FA6AC;">{{$t('view.技术附件')}}：<span @click="handleViewFile(scope.row.outFileList[0].filePath,scope.row.outFileList[0].fileName)" style="cursor: pointer;">{{scope.row.outFileList[0].fileName }}</span></span></div>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="section.sectionType==1" align="center" fixed :label="$t('view.标段名称')" width="260" >
                        <template slot-scope="scope">
                            <div>{{ locale=='en'? scope.row.sectorNameEn:locale=='lo'?scope.row.sectorNameLo:scope.row.sectorName }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column  v-if="section.quotationMethod!=1" align="center" prop="quotesPrice" :label="(section.isTax=='1'? $t('view.含税单价'):$t('view.单价'))+'('+moneyUnit+')'" width="150">
                        <template slot-scope="scope">
                            <span>{{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')  }}{{ formatNum(scope.row.quotesPrice) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="section.isTax=='1'" align="center" prop="taxRate" :label="$t('view.税率')" width="150">
                        <template slot-scope="scope">
                            <span>{{getStatus('sys_tax_rate',scope.row.taxRate)  }}</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column v-if="section.quotationMethod!=1" align="center" prop="totalMaterialPrice" :label="$t('view.物料总价')+'('+moneyUnit+')'" width="150"></el-table-column> -->
                    <el-table-column v-if="section.quotationMethod!=1" align="center" prop="otherExpenses" :label="$t('view.其他费用')+'('+moneyUnit+')'" width="150"></el-table-column>
                    <el-table-column align="center" prop="totalPrice" :label="$t('view.总价')+'('+moneyUnit+')'"  width="150">
                        <template slot-scope="scope">
                           {{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')  }}{{formatNum(scope.row.totalPrice)}}
                        </template>
                    </el-table-column>
                    <el-table-column  align="center"  v-if="!(section.sectionType != '1'&&section.engineeringType!=2)||section.successfulBidderMethod==1" prop="settleMethod" width="150" :label="$t('view.结算方式')">
                        <template slot-scope="scope">
                            <span>{{getStatus('sys_settle_method',scope.row.settleMethod)  }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column header-align="center"   prop="remarks" width="540" :label="$t('view.报价说明')">
                        <template slot-scope="scope">
                            <span v-html="scope.row.remarks"></span>
                        </template>
                    </el-table-column>
                    <el-table-column header-align="center" prop="remarks1" width="200" :label="$t('view.备注')">
                    </el-table-column>
                    <!-- <el-table-column align="center" v-if="section.sectionType!=1" prop="volume" :label="$t('view.单个体积')" width="150"></el-table-column>
                    <el-table-column align="center" v-if="section.sectionType!=1" prop="unit" :label="$t('view.体积单位')" width="150">
                        <template slot-scope="scope">
                            <span>{{getStatus('sys_volume_unit',scope.row.volumeUnit)  }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" v-if="section.sectionType!=1" prop="weight" :label="$t('view.单个重量')" width="150"></el-table-column>
                    <el-table-column align="center" v-if="section.sectionType!=1" prop="unit" :label="$t('view.重量单位')" width="150">
                        <template slot-scope="scope">
                            <span>{{getStatus('sys_weight_unit',scope.row.weightUnit)  }}</span>
                        </template>
                    </el-table-column> -->
                    <!-- <el-table-column align="center" v-if="section.showRanking&& section.rankingType==0" prop="remarks" width="150" :label="$t('view.排名')">
                        <template  slot-scope="scope">
                            <span class="mainColor">{{ scope.row.pricePank }}</span>
                        </template>
                    </el-table-column> -->
                    <el-table-column align="center" v-if="section.supplierOffer==1" prop="remarks" width="150" :label="$t('view.本轮最低价')">
                        <template  slot-scope="scope">
                            <span class="mainColor">{{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')  }}{{ scope.row.minQuotesPrice  }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center"  v-if="!(section.sectionType != '1'&&section.engineeringType!=2)" prop="fileList" width="150" :label="$t('view.附件')">
                        <template  slot-scope="scope">
                        <div class="clickText" v-for="(item,index) in scope.row.fileList" :key="index">
                            <span style="line-height: 20px;font-size: 14px;color:#409EFF" @click.stop="handleViewFile(item.filePath, item.fileName)">{{ item.fileName }}</span>
                        </div>
                        </template>
                    </el-table-column>
                </el-table>
                <el-form  v-show="item.show&&section.sectionType != '1'&&section.engineeringType!=2" disabled :model="item.quotesList[0]"  label-width="120px" style="margin-top:10px">
                    <el-form-item v-if="section.successfulBidderMethod!=1" :label="$t('view.结算方式')" prop="settleMethod">
                        <span v-if="section.settleMethod||item.quotesList[0].isForceSettleMethod==1">{{getStatus('sys_settle_method',item.quotesList[0].settleMethod)  }}</span>
                        <el-select class="BlueEditable" v-else size="mini" style="width: 320px" clearable v-model="item.quotesList[0].settleMethod">
                            <el-option v-for="item1 in sys_settle_method" :key="item1.dictValue" :label="item1.dictLabel" :value="item1.dictValue"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('view.报价说明')" prop="declareName">
                        <vue-editor  v-model="item.quotesList[0].remarks" class="my-custom-editor BlueEditable" style="width: 520px" :disabled="true"></vue-editor>
                    </el-form-item>
                    <el-form-item :label="$t('view.备注')" prop="declareName" >
                        <el-input class="BlueEditable" type="textarea" :placeholder="$t('view.请输入')"  resize='none' :rows="3" size="mini" style="width: 520px" v-model="item.quotesList[0].remarks1" ></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('view.附件')" prop="declareName">    
                        <div class="clickText" v-for="(item1,index) in item.quotesList[0].fileList" :key="index">
                            <span style="line-height: 20px;font-size: 14px;color:#409EFF" @click.stop="handleViewFile(item1.filePath, item1.fileName)">{{ item1.fileName }}</span>
                        </div>
                    </el-form-item>
                </el-form>
                <!-- 总包 -->
                <el-table v-if="section.engineeringType==2&&item.show" max-height="500" border header-row-class-name="tableHeader" :data="item.quotesList" style="width: 930px;margin-top: 15px;">
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <el-table :data="props.row.details"  border header-row-class-name="tableHeader" style="width: 100%">
                                <el-table-column align="center"   :label="$t('view.物资名称')">
                                    <template slot-scope="scope">
                                        <div>{{ ++scope.$index }}、{{ locale=='en'? scope.row.sectorNameEn:locale=='lo'?scope.row.sectorNameLo:scope.row.sectorName }}</div>
                                        <div>{{ $t('view.数量') }}：{{ scope.row.number }}{{ scope.row.detailUnits }}</div> 
                                        <div>{{$t('view.报价方式')}}：{{scope.row.quotationMethod==1?$t('view.总价'):$t('view.单价')}}（{{scope.row.moneyUnit}}/{{scope.row.detailUnits}}）</div>
                                        <div class="mainColor" v-if="scope.row.budgetAmount&&section.budgetType==2">【{{$t('view.限价')}}：{{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')  }}{{formatNum(scope.row.budgetAmount)}}（{{scope.row.moneyUnit}}/{{scope.row.detailUnits}}）】</div>
                                    </template>
                                </el-table-column>
                                <el-table-column align="center" prop="detailPrice" :label="section.isTax=='1'? $t('view.报价（含税）'):$t('view.报价')">
                                    <template slot-scope="scope">
                                        {{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')  }}{{formatNum(scope.row.detailPrice)}}
                                    </template>
                                </el-table-column>
                                <!-- 税率 -->
                                <el-table-column align="center" v-if="section.isTax=='1'" :label="$t('view.税率')">
                                    <template slot-scope="scope">
                                        <span>{{getStatus('sys_tax_rate',scope.row.taxRate)  }}</span>
                                    </template>
                                </el-table-column>
                                <!-- 系数 -->
                                <el-table-column align="center"   :label="$t('view.系数')">
                                    <template slot-scope="scope">
                                        <div v-if="scope.row.coefficientName">
                                            <span>{{ scope.row.coefficientName }}</span>
                                            <div>{{ scope.row.coefficient }}</div>
                                        </div>
                                        <div v-else>/</div>
                                    </template>
                                </el-table-column>
                                <el-table-column align="center"  :label="section.isTax=='1'? $t('view.总价（含税）') :$t('view.总价')">
                                    <template slot-scope="scope">
                                        {{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')  }}
                                        <!-- 总价 -->
                                        <span v-if="scope.row.quotationMethod==1" >{{formatNum(scope.row.detailPrice?scope.row.detailPrice:0)  }}</span>
                                        <!-- 单价 -->
                                        <span v-else>{{( formatNum((scope.row.detailPrice* scope.row.number).toFixed(4)) )}}</span>
                                    </template> 
                                </el-table-column>
                            </el-table>
                        </template>
                    </el-table-column>
                    <el-table-column  align="center" :label="$t('view.标段信息')">
                        <template slot-scope="scope">
                            <div>{{ $t('view.标段') }} {{scope.row.sort}}：{{ locale=='en'? scope.row.sectorNameEn:locale=='lo'?scope.row.sectorNameLo:scope.row.sectorName }}</div>
                            <div  class="mainColor">（{{getStatus('sys_currency',scope.row.currency)  }}/{{scope.row.moneyUnit}}）</div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="150" prop="totalPrice"  :label="section.isTax=='1'? $t('view.总价（含税）') :$t('view.总价')">
                        <template  slot-scope="scope">
                            <span class="mainColor">{{getStatus('sys_currency',scope.row.currencyTypeId?scope.row.currencyTypeId:scope.row.currency,'remark')  }}{{ formatNum(scope.row.totalPrice) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="200" prop="remarks1" :label="$t('view.备注')">
                    </el-table-column>
                </el-table>
                <div v-if="section.showRanking&& section.rankingType==1" style="display:flex;margin: 15px 0;align-items: flex-end;flex-direction:row-reverse;">
                    <div>{{$t('view.整体总价')}}：
                        <span class="mainColor" style="font-size:24px;font-weight:600">{{getStatus('sys_currency',item.currencyTypeId?item.currencyTypeId:item.currency,'remark')  }}{{ formatNum(item.totalPrice) }}{{ moneyUnit }}</span>
                    </div>
                    <!-- <div style="margin-right:20px">{{$t('view.整体排名')}}：
                        <span class="mainColor" style="font-size:24px;font-weight:600">{{ item.pricePank }}</span></div> -->
                </div>
            </div>
        </div>
        <!-- 图片预览 -->
        <el-image ref="preview" v-show='false' class="hideImgDiv" :src="url" :preview-src-list="[url]" ></el-image>
        <!-- 弃标 -->
        <div class="btnList whiteBox" v-if="details.supplierBidStatus<20&&details.supplierBidStatus!=-1&&!details.disabled">
            <el-button style="min-width: 120px;" type="primary" @click="signupUpdateSupplierBidStatus" >{{$t('view.弃标')}}</el-button>
        </div>
        <!-- 查看标书文件未过的原因 -->
        <el-dialog :visible.sync="reasonsVisible" width="30%" :before-close="beforeClose">
            <span>{{$t('view.未通过原因')}}：{{ reasonsText }}</span>
        </el-dialog>

        <!-- 按钮的位置 -->
        <!-- <div style="width: 100%;height: 60px;"></div> -->

    </div>
  </template>

<script>
import { uploadFileBpm } from '@/utils/request'
import { getToken } from "@/utils/auth";
import {getQuotationInfo, exportSectorsDetails, importFileSectorsDetails} from '@/api/PersonalCenter'
import BarKemajuan from '@/components/BarKemajuan.vue'
import File from '@/components/file.vue'
import {getDicts} from '@/api/index'
import {authorizationVerify} from '@/api/project'
import { VueEditor } from 'vue2-editor';
import { timeCountDown,arabicToChinese,convertCurrency} from "@/utils/sczn";
import {triggerUpdateStatus, signupCancelSupplierBidFile,signupGetWithAuth,signuSubmitQuotesFile,signupSubmitQualification,signupSubmitPayment,signupSubmitSupplierBidFile,signupUpdateSupplierBidStatus,quotesSupplierQuotesSum,marginSignupId,refundConfirm,questionBidAnnounceQuestion,sectionAcceptPaymentMethods,quotationSupplierBaseFile, submitWinningQuotes} from '@/api/project'
  export default {    
    components:{BarKemajuan,File,VueEditor},
    data(){
        return{
            loading:true,
            moneyUnit:"",
            bidAwardManageDetailList:[],
            arabicToChinese,//数字转大写
            timeCountDown,//倒计时
            convertCurrency,//金额
            url:'',//预览的图片
            reasonsVisible:false,//标书未过弹窗
            reasonsText:'',//标书未过的原因
            basicTable:[],//基本信息
            appealShow:false,//申诉问题 显示
            appealTable:[{type:'',problemDescription:''}],//申诉问题
            sys_section_type:[],
            RefundDeposit:{},//退还保证金
            HistoricalQuotation:[],//历史报价
            sys_supplier_margin_status:[],//投标文件 状态
            reupload:false,//资质上传 重新上传的判断
            sys_settle_method:[],//结算方式
            bid_announce_question_type:[],//申诉问题 类型字典
            receivingAccountList:[],// 标书、保证金
            BiddingResultsList:{isWinningBid:0},//招标结果列表
            sys_bidding_method:[],
            supply_type:[],
            details:{supplierBaseFile:{},quotesNoteFileList:[]},
            uploadFileBpm,
            BpmData:{},//上传时穿的参数
            tableData:[],
            locale: localStorage.getItem('locale')||'zh',
            section:{},
            user:{
                supplierName:''
            },
            headers: {
                Authorization:getToken(),
            },
            sys_volume_unit:[],//体积单位
            sys_weight_unit:[],//重量单位
            sys_currency:[],
            sys_tax_rate:[],
            qualificationsShow:true,//资质上传是否显示
            detailsList:[],
            scheduleList:[{schedule:1,title:this.$t('view.投标信息')},{schedule:6,title:this.$t('view.资质审核')},{schedule:8,title:this.$t('view.缴纳保证金')},{schedule:11,title:this.$t('view.项目标书')},{schedule:15,title:this.$t('view.投标竞价')},{schedule:20,title:this.$t('view.定标')}]
        }
    },
    created(){
        this.getDicts('sys_section_type')
        this.getDicts('sys_currency')//币种
        this.getDicts('sys_weight_unit')//重量单位
        this.getDicts('sys_volume_unit')//体积单位
        this.getDicts('sys_supplier_margin_status')//投标文件 状态
        this.getDicts('sys_bidding_method') //招标方式
        this.getDicts('sys_settle_method')
        this.getDicts('supply_type')
        this.getDicts('bid_announce_question_type')//公式问题 类型
        this.getDicts('sys_tax_rate')//税率
        this.signupGetWithAuth()

    },
    methods:{
        Refresh(){
            triggerUpdateStatus(this.details.sectionId).then(res=>{
                this.$parent.$parent.$refs.PopUpPrompt.open(this.$t('view.当前项目已开标'))
                setTimeout(function(){
                    location.reload()
                },5000)
            })
        },
        // 报价说明上传
        signuSubmitQuotesFile(){
            // if(this.details.supplierBidStatus!=18 && new Date().getTime() > new Date(this.details.fileDeadlineTime).getTime()){
            //     this.$message.warning(this.$t('view.已过提交时间'))
            //     return
            // }
            if(this.details.quotesNoteFileList.length==0){
                this.$message.warning(this.$t('view.请上传')+this.$t('view.报价说明文件'))
                return
            }
            signuSubmitQuotesFile({
                id:this.$route.query.id,
                fileList:this.details.quotesNoteFileList
            }).then(res=>{
                if(res.code==200){
                    this.$message.success(this.$t('view.提交成功'));
                    location.reload()
                }
            })
        },
        // 基础文件提交
        quotationSupplierBaseFile(){
            this.details.supplierBaseFile.qualificationAgencyLicenseFileList=this.details.qualificationAgencyLicenseFileList
            this.details.supplierBaseFile.qualificationOtherFileList=this.details.qualificationOtherFileList
            if(!this.details.supplierBaseFile.supTecFileList.length&&this.details.isQualificationTec==1) return this.$message.warning(this.$t('view.请上传') +this.$t('view.供应商技术文件'))
            if(!this.details.supplierBaseFile.supAchFileList.length&&this.details.isQualificationAchievement==1) return this.$message.warning(this.$t('view.请上传') +this.$t('view.供应商业绩文件'))
            if(!this.details.supplierBaseFile.qualificationAgencyLicenseFileList.length&&this.details.isQualificationAgencyLicense==1) return this.$message.warning(this.$t('view.请上传') +this.$t('view.代理许可证'))
            if(!this.details.supplierBaseFile.qualificationOtherFileList.length&&this.details.isQualificationOther==1) return this.$message.warning(this.$t('view.请上传') +(this.locale=='en'? this.section.qualificationOtherDescribeEn:this.locale=='lo'?this.section.qualificationOtherDescribeLo:this.section.qualificationOtherDescribe))
            this.details.supplierBaseFile.signUpId=this.$route.query.id
            this.details.supplierBaseFile.sectionId=this.details.sectionId
            quotationSupplierBaseFile(this.details.supplierBaseFile).then(res=>{
                if(res.code==200){
                    this.$message.success(this.$t('view.提交成功'));
                    location.reload()
                }

            })
        },
        //合并单元格
       objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            // 如果不是最后一行，不处理
            if (rowIndex !== this.basicTable.length - 1) {
                return { rowspan: 1, colspan: 1 };
            }

            // 检查最后一行右边内容是否为空
            const lastRow = this.basicTable[this.basicTable.length - 1];
            const isRightEmpty = !lastRow.RightValue || lastRow.RightValue.trim() === '';

            // 如果右边内容为空，则合并
            if (isRightEmpty) {
                if (columnIndex === 0) { // LeftTitle列：保持不变
                    return { rowspan: 1, colspan: 1 };
                } else if (columnIndex === 1) { // LeftValue列：向右合并3列（覆盖RightTitle和RightValue）
                    return { rowspan: 1, colspan: 3 };
                } else if (columnIndex === 2 || columnIndex === 3) { // RightTitle和RightValue列：隐藏
                    return { rowspan: 0, colspan: 0 };
                }
            }

            // 默认情况：不合并
            return { rowspan: 1, colspan: 1 };
        },

        // 关闭弹窗
        beforeClose(){
            this.reasonsVisible=false
        },
        //弹窗 标书未过原因
        reasons(){
            this.reasonsText=this.details.bidFileReviewRemark
            this.reasonsVisible=true
        },
        fileUploadFile(){
            let nowTime =new Date().getTime();
            let end =new Date(this.section.bidFileEndTime).getTime()
            let start =new Date(this.section.bidFileStartTime).getTime()

            if(nowTime<end&&nowTime>start){
                this.$refs.upload1.$refs["upload-inner"].handleClick();
            }else{
                this.$message.warning(this.$t('view.请在标书递交开始时间进行递交'))
            }

        },
        // 提交申诉问题
        questionBidAnnounceQuestion(){
            for(let i=0;i<this.appealTable.length;i++){
                if(!this.appealTable[i].type||!this.appealTable[i].problemDescription){
                    this.$message.warning(this.$t('view.请完善信息'))
                    return
                }
            }
            questionBidAnnounceQuestion({
                sectionId:this.details.sectionId,
                type:this.appealTable[0].type,
                status:1,
                problemDescription:this.appealTable[0].problemDescription
            }).then(res=>{
                if(res.code==200){
                    this.$message.success(this.$t('view.操作成功'))
                    this.$router.push('MyBid')
                }
            })
        },
        // 保证金确认
        refundConfirm(){
            this.$confirm(this.$t('view.保证金是否确认收到'), this.$t('view.提示'), {
                confirmButtonText: this.$t('view.确定'),
                cancelButtonText: this.$t('view.取消'),
                type: 'warning'
            }).then(() => {
                refundConfirm({
                    marginId:this.RefundDeposit.id
                }).then(res=>{
                    if(res.code==200){
                        this.$message.success(this.$t('view.操作成功'))
                        this.$router.push('MyBid')
                    }
                })
            })
        },
        // 获取保证金详情
        marginSignupId(){
            marginSignupId(this.$route.query.id).then(res=>{
                this.RefundDeposit=res.data
                this.RefundDeposit.fileList.map(item=>{
                    item.type= item.fileName.split(".").pop()
                })
                if(this.RefundDeposit.refundDateDeadline){
                    this.timeCountDown(this.RefundDeposit.refundDateDeadline,'', (value,clear)=>{
                        this.$set(this.RefundDeposit,'timeList',value)
                        this.$once('hook:beforeDestroy', clear);
                    })
                }

            })
        },
        //查询投标结果
        quotesSupplierQuotesSum(){
            quotesSupplierQuotesSum({
                sectionId:this.details.sectionId
            }).then(res=>{
                this.BiddingResultsList=res.data
                
            })
        },
        // 查询历史记录
        getQuotationInfo(){
            getQuotationInfo(this.details.sectionId).then(res=>{
                res.data.map(item=>{
                    this.$set(item,'show',false)
                })
                this.HistoricalQuotation=res.data
                // res.data.map(item=>{
                //     if(!this.HistoricalQuotation[item.quotesCount-1])
                //     this.HistoricalQuotation[item.quotesCount-1]=[]
                //     this.HistoricalQuotation[item.quotesCount-1].push(item)
                // })
                // this.HistoricalQuotation.map(item=>item.reverse())
                // // 倒叙
                this.HistoricalQuotation.reverse()
            })
        },
        // 撤回标书
        signupCancelSupplierBidFile(){
            signupCancelSupplierBidFile({
                id:this.$route.query.id,
            }).then(res=>{
                this.$message.success(this.$t('view.操作成功'))
                location.reload()
            })
        },
        // 弃标
        signupUpdateSupplierBidStatus(){
            this.$confirm(this.$t('view.是否要放弃该标'), this.$t('view.提示'), {
                confirmButtonText: this.$t('view.确定'),
                cancelButtonText: this.$t('view.取消'),
                type: 'warning'
            }).then(() => {
                signupUpdateSupplierBidStatus({
                    id:this.$route.query.id,
                    supplierBidStatus:-1
                }).then(res=>{
                    if(res.code==200){
                        this.$message.success(this.$t('view.操作成功'))
                        this.$router.push('MyBid')
                    }
                })
            })
        },
        // 查看图片
        viewPicture(img){
            this.url=img
            this.$refs.preview.clickHandler();
        },
        // 重新上传
        reuploadClick(list){
            if(list.split('.').length==1){
                this.$set(this.details,list,[])
            }else{
                let a =list.split('.')
                this.$set(this.details[a[0]],a[1],[])
            }
        },
        // 提交缴费信息
        signupSubmitPayment(){
            for(let i=0;i<this.receivingAccountList.length;i++){
                if(this.receivingAccountList[i].fileList.length!=1){
                    this.$message.warning(this.$t('view.请上传缴费证明'))
                    return
                }
            }
            signupSubmitPayment({
                id:this.$route.query.id,
                receivingAccountList:this.receivingAccountList
            }).then(res=>{
                this.$message.success(this.$t('view.提交成功'));
                location.reload()
            })
        },
        signupSubmit(type){
            signupSubmitQualification({
                id:this.$route.query.id,
                qualificationBusinessLicenseFileList:this.details.qualificationBusinessLicenseFileList,
                qualificationAchievementFileList:this.details.qualificationAchievementFileList,
                qualificationAgencyLicenseFileList:this.details.qualificationAgencyLicenseFileList,
                qualificationOtherFileList:this.details.qualificationOtherFileList,
                sectionId:this.details.sectionId
            }).then(res=>{
                if(res.code==200){
                    this.$message.success(this.$t('view.提交成功'));
                    location.reload()
                }

            })
        },
        // 是否接受当前支付方式
        sectionAcceptPaymentMethods(acceptPaymentMethods){
            sectionAcceptPaymentMethods({
                sectionId:this.details.sectionId,
                acceptPaymentMethods:acceptPaymentMethods
            }).then(res=>{
                this.$router.push({path:'quotation',query:{id:this.details.sectionId}})
            })
        },
        // 提交资质
        signupSubmitQualification(){
            if(!this.details.qualificationBusinessLicenseFileList.length&&this.details.isQualificationBusinessLicense==1) return this.$message.warning(this.$t('view.请上传营业执照资质'))
            if(!this.details.qualificationAchievementFileList.length&&this.details.isQualificationAchievement==1) return this.$message.warning(this.$t('view.请上传业绩'))
            if(!this.details.qualificationAgencyLicenseFileList.length&&this.details.isQualificationAgencyLicense==1) return this.$message.warning(this.$t('view.请上传代理许可'))
            if(!this.details.qualificationOtherFileList.length&&this.details.isQualificationOther==1) return this.$message.warning(this.$t('view.请上传')+(this.locale=='en'? this.details.qualificationOtherDescribeEn:this.locale=='lo'?this.details.qualificationOtherDescribeLo:this.details.qualificationOtherDescribe))
            this.signupSubmit()
        },
        beforeAvatarUpload(file){
            if((!file.type.includes('pdf'))&&(!file.type.includes('image'))&&(!file.type.includes('zip'))&&(!file.type.includes('application/x-compressed'))){
                this.$message.error(this.$t('view.格式有误'));
                return false
            }
            return true
        },
        // 上传标书
        signupSubmitSupplierBidFile(flie){

            signupSubmitSupplierBidFile({
                id:this.$route.query.id,
                supplierBidFileList:[{
                    fileName:flie.data.fileName,
                    filePath:flie.data.filePath,
                    url: flie.data.url,
                    bpmFileId:flie.data.bpmFileId
                }]
            }).then(res=>{
                this.$message.success(this.$t('view.提交成功'));
                location.reload()
            })
        },
        // 上传文件
        successList(list,res,file){
            if(res.code!=200) return this.$message.error(this.$t('view.上传失败'))
            if(!list)
            list=[]
            list.push({
                fileName:file.response.data.fileName,
                filePath:file.response.data.filePath,
                url: file.response.data.url,
                type:file.response.data.fileName.split(".").pop(),
                fileSize:file.size,
                bpmFileId:file.response.data.bpmFileId,
            })
        },
        // 删除文件 保证金、标书
        handleRemoveClear(index){
            this.$set(this.receivingAccountList[index],'fileList',[])
        },
        // 删除
        handleRemove(list, file, fileList) {
            this.$set(this.details,list,[])
            fileList.map(item=>{
                this.details[list].push({
                    fileName:item.response.originalFilename,
                    filePath:item.response.fileName,
                    url: item.response.url,
                })
            })
        },
        handleViewFile1(filePath, fileName){
            const eLink = document.createElement("a");
            eLink.style.display = "none";
            let url = filePath.indexOf('http')>-1?filePath:this.MINIO_PREVIEW_URL+filePath;
            fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
                eLink.href = URL.createObjectURL(blob)
                eLink.download = fileName;
                document.body.appendChild(eLink)
                eLink.click();
                eLink.remove()
            })
        },
         // 附件查看与下载
        handleViewFile(filePath, fileName) {
            const ext = filePath.substr(filePath.lastIndexOf('.') + 1, filePath.length)
            if (ext == 'pdf' || 'PDF') {
                window.open(filePath, "_blank");
            } else {
                const eLink = document.createElement("a");
                eLink.download = fileName;
                eLink.style.display = "none";
                eLink.href = filePath;
                document.body.appendChild(eLink);
                eLink.click();
                eLink.remove()
            }
        },
        // 字典项
        getDicts(type){
            getDicts(type).then(res=>{
                res.data.map(item=>{
                    item.dictLabel=this.locale=='en'?item.dictLabelEn:this.locale=='lo'?item.dictLabelLo:item.dictLabel
                })
                this[type]=res.data
            })
        },
        // 跳转页面
        Jumps(url,id){
            let routeUrl= this.$router.resolve({
                path: url,
                query: {id:id,biddingType:this.section.biddingType}
            })
            window.open(routeUrl.href, '_blank');
        },
        // 跳转页面
        async Jump(url,id){
            if(url=='quotation'){
                let res=await authorizationVerify()
                if(res.data.operation =='Auth' ||res.data.operation=='modify' ){
                    return this.$message({  message: '当前用户没有进行认证，请先进行信息认证',type: "warning",});

                }else if(res.data.operation =='prompt'){
                    return this.$message({  message: '企业认证正在进行中，请耐心等待',type: "warning",});
                } 
                if(this.section.biddingType==0 || localStorage.getItem(this.$store.getters.userId+this.details.sectionId)||this.HistoricalQuotation.length){
                    // biddingType 0招标 1询价
                    let routeUrl= this.$router.resolve({
                        path: url,
                        query: {id:id}
                    })
                    window.open(routeUrl.href, '_blank');
                }else{
                    if(this.section.settleMethod===''){
                        this.sectionAcceptPaymentMethods('0')
                        return
                    }
                    this.$confirm(this.$t('view.是否接受当前结算方式')+'：'+(this.section.settleMethod==='0'?this.$t('view.先款后货'):this.section.settleMethod==1?this.$t('view.先货后款'):this.section.settleMethod==2?this.$t('view.按比例支付'):'') , this.$t('view.提示'), {
                        confirmButtonText: this.$t('view.接受'),
                        cancelButtonText:this.$t('view.不接受'),
                        distinguishCancelAndClose:true,
                        type: 'warning'
                    }).then(() => {
                        this.$router.push({path:'quotation',query:{id:this.details.sectionId}})
                    }).catch(action=>{
                        //点击取消
                        if(action=='cancel'){
                            this.sectionAcceptPaymentMethods('0')
                        }
                    })
                }
            }else{
                // biddingType 0招标 1询价
                let routeUrl= this.$router.resolve({
                    path: url,
                    query: {id:id}
                })

                window.open(routeUrl.href, '_blank');
            }

        },
        signupGetWithAuth(){
            signupGetWithAuth(this.$route.query.id).then(res=>{

                this.user=res.data.user
                if(res.data.section.sectorList){
                    if(res.data.section.sectorList[0].details){
                        res.data.section.sectorList[0].details.map(item=>{
                            item.sectorPrice = item.sectorPrice || '';
                            item.otherExpenses = item.otherExpenses || '';
                        })
                    }
                }
                this.details=res.data
               // this.bidAwardManageDetailList=res.data.section.sectorList
                 this.bidAwardManageDetailList= res.data.section.successfulBidderMethod==1 ?res.data.bidAwardManageDetailList:res.data.section.sectorList
                if(!this.details.supplierBaseFile.supAchFileList)
                this.details.supplierBaseFile.supAchFileList=[]
                if(!this.details.supplierBaseFile.supTecFileList)
                this.details.supplierBaseFile.supTecFileList=[]
                // 按钮能不能点击
                this.details.disabled=(this.details.sectionStauts==15||this.details.sectionStauts==12||(this.details.sectionStauts==2 &&this.details.isAppointSupplierQuotationIng==0)||this.details.sectionStauts==13||this.details.sectionStauts==14||this.details.sectionStauts==6||this.details.supplierBidStatus==-1)?true:false
                this.section=res.data.section
                this.moneyUnit = (this.locale=='en'?this.section.moneyUnitEn:this.locale=='lo'?this.section.moneyUnitLo:this.section.moneyUnit);
                this.BpmData={
                    type:"xytzbwdbsq",
                    sectionId:this.details.sectionId,
                }
                let data=this.section 
                if(this.section.biddingType!=0){
                    this.basicTable=this.buildDetailRows([
                        this.$t('view.询价单位'),data.organization,
                        this.$t('view.项目类型'),this.getStatus('sys_section_type',data.projectType) ,
                         this.$t('view.物资分类'),this.getStatus('supply_type',data.projectMaterialType),
                        this.$t('view.中标方式') ,data.successfulBidderMethod==1?this.$t('view.分项'):this.$t('view.整体'),
                        this.$t('view.报价方式'),data.quotationMethod==0?this.$t('view.单价'):this.$t('view.总价'),
                        this.$t('view.是否公开询价'),data.biddingMethod==1?this.$t('view.是'):this.$t('view.否'),
                        this.$t('view.是否含税'),data.isTax==1?this.$t('view.是'):this.$t('view.否'),
                        this.$t('view.币种'),this.getStatus('sys_currency',data.currency),
                        this.$t('view.结算方式'),data.settleMethod==='0'?this.$t('view.先款后货'):data.settleMethod==1?this.$t('view.先货后款'):data.settleMethod==2?this.$t('view.按比例支付'):'',
                        this.$t('view.询价截止时间'),data.entTime,  
                        this.$t('view.期望到货日期'),data.expectedDeliveryDate,
                        this.$t('view.联系人'),data.businessContacts,  
                        this.$t('view.联系电话'),data.businessPhoneNumber])
                }else{
                    if(data.documentsAmount&&data.securityDeposit){
                        this.basicTable=this.buildDetailRows([
                            this.$t('view.招标名称'),this.locale=='en'?data.sectionNameEn:this.locale=='lo'?data.sectionNameLo: data.sectionName,
                            this.$t('view.招标单位'),data.organization ,
                            this.$t('view.项目类型'),this.getStatus('sys_section_type',data.projectType),
                             this.$t('view.物资分类'),this.getStatus('supply_type',data.projectMaterialType),
                            this.$t('view.质保期'),data.warranty ,
                            this.$t('view.报名开始时间'),data.signupStartTime,
                            this.$t('view.报名结束时间'),data.signupEndTime ,
                            this.$t('view.币种'),this.getStatus('sys_currency',data.currency),
                            this.$t('view.是否含税'),this.section.isTax=='1'?this.$t('view.是'):this.$t('view.否'),
                            this.$t('view.标书费用'),data.documentsAmount ,
                            this.$t('view.竞价保证金'),data.securityDeposit ,
                            this.$t('view.招标方式'),this.getStatus('sys_bidding_method',data.biddingMethod),
                            this.$t('view.中标方式'),data.successfulBidderMethod==1?this.$t('view.分项'):this.$t('view.整体') ,
                            this.$t('view.招标公告'),this.$t('view.招标公告')])
                    }else if(data.securityDeposit){
                        this.basicTable=this.buildDetailRows([
                            this.$t('view.招标名称'),this.locale=='en'?data.sectionNameEn:this.locale=='lo'?data.sectionNameLo: data.sectionName,
                            this.$t('view.招标单位'), data.organization ,
                            this.$t('view.项目类型'),this.getStatus('sys_section_type',data.projectType),
                             this.$t('view.物资分类'),this.getStatus('supply_type',data.projectMaterialType),
                            this.$t('view.质保期'),data.warranty ,
                            this.$t('view.报名开始时间'),data.signupStartTime,
                            this.$t('view.报名结束时间'),data.signupEndTime ,
                            this.$t('view.币种'),this.getStatus('sys_currency',data.currency),
                            this.$t('view.是否含税'),this.section.isTax=='1'?this.$t('view.是'):this.$t('view.否'),
                            this.$t('view.竞价保证金'),data.securityDeposit,
                            this.$t('view.招标方式'),this.getStatus('sys_bidding_method',data.biddingMethod),
                            this.$t('view.中标方式'),data.successfulBidderMethod==1?this.$t('view.分项'):this.$t('view.整体'),
                            this.$t('view.招标公告'),this.$t('view.招标公告')])
                        
                    }else if(data.documentsAmount){
                        this.basicTable=this.buildDetailRows([
                           this.$t('view.招标名称'),this.locale=='en'?data.sectionNameEn:this.locale=='lo'?data.sectionNameLo: data.sectionName,
                           this.$t('view.招标单位'),data.organization ,
                            this.$t('view.项目类型'),this.getStatus('sys_section_type',data.projectType),
                             this.$t('view.物资分类'),this.getStatus('supply_type',data.projectMaterialType),
                            this.$t('view.质保期'),data.warranty ,
                            this.$t('view.报名开始时间'),data.signupStartTime,
                            this.$t('view.报名结束时间'),data.signupEndTime ,
                            this.$t('view.币种'),this.getStatus('sys_currency',data.currency),
                            this.$t('view.是否含税'),this.section.isTax=='1'?this.$t('view.是'):this.$t('view.否'),
                            this.$t('view.标书费用'),data.documentsAmount  ,
                            this.$t('view.招标方式'),this.getStatus('sys_bidding_method',data.biddingMethod),
                            this.$t('view.中标方式'),data.successfulBidderMethod==1?this.$t('view.分项'):this.$t('view.整体'),
                            this.$t('view.招标公告'),this.$t('view.招标公告')]) 
                    }else{
                        this.basicTable=this.buildDetailRows([
                            this.$t('view.招标名称'),this.locale=='en'?data.sectionNameEn:this.locale=='lo'?data.sectionNameLo: data.sectionName,
                            this.$t('view.招标单位'),data.organization,
                            this.$t('view.项目类型'),this.getStatus('sys_section_type',data.projectType),
                             this.$t('view.物资分类'),this.getStatus('supply_type',data.projectMaterialType),
                            this.$t('view.质保期'),data.warranty ,
                            this.$t('view.报名开始时间'),data.signupStartTime,
                            this.$t('view.报名结束时间'),data.signupEndTime ,
                            this.$t('view.币种'),this.getStatus('sys_currency',data.currency),
                            this.$t('view.是否含税'),this.section.isTax=='1'?this.$t('view.是'):this.$t('view.否'),
                            this.$t('view.招标方式'),this.getStatus('sys_bidding_method',data.biddingMethod),
                            this.$t('view.中标方式'),data.successfulBidderMethod==1?this.$t('view.分项'):this.$t('view.整体') ,
                            this.$t('view.招标公告'),this.$t('view.招标公告')])
                    }

                }
                // 邀请招标隐藏报名时间
                if(this.section.biddingMethod==0){
                    this.basicTable = this.basicTable.filter(item => item.LeftTitle != this.$t('view.报名开始时间'));
                    this.basicTable = this.basicTable.filter(item => item.RightTitle != this.$t('view.报名结束时间'));
                }
                if ( data.isEntrustedBid === 1 &&this.basicTable.length > 0) {
                    // 保存原始表格数据用于处理移位
                    const originalTable = [...this.basicTable];
                    // 新表格数组，先放入委托投标项
                    const newTable = [{
                        // 原第一项的Left内容保持在左侧
                        LeftTitle: originalTable[0].LeftTitle,
                        LeftValue: originalTable[0].LeftValue,
                        // 将委托投标信息放到右侧
                        RightTitle: this.$t('view.建设单位'),
                        RightValue: data.constructionOrganizationName
                    }];
                    
                    // 处理后续项的移位逻辑
                    for (let i = 0; i < originalTable.length; i++) {
                        // 当前项存在右内容时才需要处理移位
                        if (originalTable[i].RightTitle) {
                            newTable.push({
                                LeftTitle: originalTable[i].RightTitle,
                                LeftValue: originalTable[i].RightValue,
                                // 如果有下一项，使用下一项的Left作为当前项的Right
                                RightTitle: originalTable[i + 1]?.LeftTitle || '',
                                RightValue: originalTable[i + 1]?.LeftValue || ''
                            });
                        }
                    }
                    
                    // 使用处理后的新表格
                    this.basicTable = newTable;
                }

                if(this.details.supplierBidStatus==10)
                res.data.receivingAccountList.map(item=>item.fileList=[])
                this.receivingAccountList=res.data.receivingAccountList
                // 要显示倒计时
                if(this.details.supplierBidStatus>0&&this.details.supplierBidStatus<15&&(this.section.sectionStauts==5||this.section.sectionStauts==11)){
                    this.timeCountDown(this.section.startTime,'view.已开标', (value,clear)=>{
                        this.$set(this.section,'bidOpeningList',value)
                    },this.Refresh)
                }
                if(this.details.supplierBidStatus ==11||this.details.supplierBidStatus==13){
                    this.timeCountDown(this.section.bidFileEndTime,'', (value,clear)=>{
                        this.$set(this.section,'timeList',value)
                        this.$once('hook:beforeDestroy', clear);
                    })
                }
                this.receivingAccountList.map(item=>{
                    item.fileList.map(i=>{
                        i.type= i.fileName.split(".").pop()
                    })
                })
                if(this.details.supplierBidStatus==8||this.details.supplierBidStatus==10){
                    this.receivingAccountList.map(item=>{

                        this.timeCountDown(item.paymentDeadline,'', (value,clear)=>{
                            this.$set(item,'timeList',value)
                            this.$once('hook:beforeDestroy', clear);
                        })
                    })
                }
                if(this.details.supplierBidStatus>14)
                this.getQuotationInfo()
                // if(this.details.supplierBidStatus==19||this.details.supplierBidStatus==20)
                // this.quotesSupplierQuotesSum()
                if((this.section.securityDeposit>0)&& (this.details.sectionStauts==13||this.details.sectionStauts==6||this.details.sectionStauts==14)&&this.section.biddingType==0)
                this.marginSignupId()

                if(this.details.isQualificationOther!=1&& this.details.isQualificationAgencyLicense!=1&&this.details.isQualificationAchievement!=1&&this.details.isQualificationBusinessLicense!=1){
                    this.qualificationsShow=false
                    this.scheduleList = this.scheduleList.filter(item => item.schedule != 6);
                }
                if(this.receivingAccountList.length==0){
                    this.scheduleList = this.scheduleList.filter(item => item.schedule != 8);
                }
                if(this.section.isBiddingCommitFile==0){
                    this.scheduleList = this.scheduleList.filter(item => item.schedule != 11);
                }
                this.loading=false
            })
        },
        buildDetailRows(flatArr) {
            const result = [];
            const arr = [...flatArr];
            while (arr.length > 0) {
                const LeftTitle = arr.shift() ?? '';
                const LeftValue = arr.shift() ?? '';
                const RightTitle = arr.shift() ?? '';
                const RightValue = arr.shift() ?? '';
                result.push({ LeftTitle, LeftValue, RightTitle, RightValue });
            }
            return result;
        },
        handleExport() {
            exportSectorsDetails(this.details.sectionId,this.$t('view.报价模板')).then(res=>{
            })
        },
        importFile(param) {
            const formData = new FormData();
            formData.append("file", param.file);
            const loading = this.$loading({
            lock: true,
            text: this.$t('view.导入中'),
            spinner: 'el-icon-loading',
            });
            importFileSectorsDetails(this.details.sectionId,formData).then((response) => {
                if (response.code == 200) {
                    this.bidAwardManageDetailList=response.data
                    this.$modal.msgSuccess(this.$t('view.导入成功'));
                    loading.close();

                } else {
                    this.$message({  message: this.$t('view.操作失败'),type: "warning",});
                    loading.close();
                }

            }).catch((err)=>{
                loading.close();
            });
        },
        submitWinningQuotes(){
            this.bidAwardManageDetailList.map(item=>{
                item.details.map(i=>{
                    i.totalMaterialPrice = (Math.floor(i.sectorPrice * 10000) / 10000 * i.sectorNumber).toFixed(4);
                    i.totalPrice = (Math.floor(i.otherExpenses*10000)/10000+Math.floor(i.sectorPrice*10000)/10000*i.sectorNumber).toFixed(4);
                })
            })
            submitWinningQuotes({
                    sectionId:this.details.sectionId,
                    sectorList:this.bidAwardManageDetailList
                }).then((response) => {
                if (response.code == 200) {
                    this.$message.success(this.$t('view.提交成功'));
                    window.location.reload();
                }
                // else {
                //     this.$message({  message: this.$t('view.操作失败'),type: "warning",});
                // }

            })
        },
        rowClass(row, column, rowIndex, columnIndex){
            if(row.column.property=='LeftTitle'||row.column.property=='RightTitle'){
                return "background: #F2F6FC;color: #909399;"
            }
        },
    }
};
</script>
<style lang="scss" scoped>
    .title1{
        font-size: 18px;
        color: #303133;
        font-weight: 600;
    }
    .TypeBox{
        background: $mainBody-color;
        border-radius: 10px;
        line-height: 30px;
        width: 100px;
        font-weight: 700;
        color: #fff;
        margin: 10px 0;
        margin-right: 20px;
        text-align: center;
    }

    ::v-deep.hide .el-upload--text{
        display: none;
    }
    .title{
        font-size: 16px;
        font-weight: 700;
    }
    .box{
        display: flex;
        flex-wrap: wrap;
    }
    .item{
        margin-bottom: 10px;
        color: #909399;
        font-size: 14px;
        display: flex;
        align-items: center;
        line-height: 35px;
        :last-child{
            color: #333333;
        }
    }

    .redtext{
        color: $mainBody-color;
    }
    .annexList{
        display: flex;
        margin-bottom: 20px;
        font-size: 14px;
        color: #303133;
        div:first-child{
            color: #909399;
        }
    }
    .btnList{
        text-align: center;
        // position: fixed;
        // bottom: 20px;
        height: 40px;
        width: 980px;
        z-index: 9;
    }
    .Round{
        font-size: 20px;
        font-weight: 600;
        text-align: center;
        color: #303133;
        margin: 10px 0 20px 0;
    }
    .lineItem{
        margin-bottom: 10px;
        color: #909399;
        font-size: 14px;
        display: flex;
        align-items: center;
        :last-child{
            color: #333333;
        }
    }
    .payBtn{
        width: 138px;
        height: 40px;
        line-height:40px;
        background: #FFFFFF;
        text-align: center;
        border-radius: 2px;
        border: 1px solid #FFB533;
        color: #FFB533;
        margin-left: 90px;
    }
</style>
